import type { SiteMessages } from '@nanning/ui';

/** 集团门户专属文案（页面 UI 文案）。业务内容来自 data/*.json，不在这里写死。中英键必须成对。 */
export const GROUP_MESSAGES: SiteMessages = {
  zh: {
    'nav.publications': '集团刊物',
    'pub.eyebrow': '集团刊物',
    'pub.title': '集团刊物',
    'pub.type.letter': '年度信',
    'pub.type.review': '年度回顾',
    'pub.type.esg': '社会责任',
    'pub.type.facts': '数据一览',
    'pub.notice': '本页内容为集团层面的一般性说明，不构成投资建议或业绩承诺；涉及财务与政策的表述以其原始文件及主管部门最终核定为准。',
    'brand.name': '安迪文化',
    'brand.mark': 'ri-building-2-line',
    'brand.home': '集团门户',
    'nav.about': '集团概况',
    'nav.leadership': '领导致辞',
    'nav.ecosystem': '业务生态',
    'nav.news': '新闻动态',
    'nav.esg': 'ESG 与社会责任',
    'nav.ir': '投资者关系',
    'nav.careers': '加入我们',
    'nav.contact': '联系我们',
    'footer.note':
      '安迪文化对外信息发布平台。图片署名见各页图注。',
    'footer.ecosystem': '业务生态',
    'footer.site': '安迪文化',
    'common.visit': '进入',
    'common.more': '了解更多',
    'common.placeholderVisual': '业务板块配图',
    'common.imageCredit': '图片',

    'home.hero.eyebrow': '安迪文化 · 南宁',
    'home.hero.cta.ecosystem': '探索业务生态',
    'home.hero.cta.about': '了解集团',
    'home.eco.eyebrow': '业务生态',
    'home.eco.title': '五大业务，一键直达',
    'home.eco.lead': '每个业务板块都有独立的官网与栏目，点击即可进入对应子站。',
    'home.about.eyebrow': '集团概况',
    'home.about.title': '总部南宁，连接五大业务',
    'home.about.more': '查看集团概况',
    'home.facts.founded': '成立时间',
    'home.facts.capital': '注册资本',
    'home.facts.hq': '总部所在地',
    'home.facts.lines': '业务板块',
    'home.facts.linesValue': '5 个',
    'home.news.eyebrow': '新闻动态',
    'home.news.title': '最新动态',
    'home.news.all': '查看全部新闻',
    'home.esg.eyebrow': 'ESG 与社会责任',
    'home.esg.title': '在本地深耕，对环境与社区负责',
    'home.esg.env': '环境',
    'home.esg.env.body': '关注绿色履约与节能运营，逐步披露关键环境指标。',
    'home.esg.social': '社会',
    'home.esg.social.body': '服务本地客户与合作伙伴，支持人才培养与社区活动。',
    'home.esg.gov': '治理',
    'home.esg.gov.body': '各业务板块独立核算、独立负责，集团统一合规与风控。',
    'home.esg.cta': '查看 ESG 议题',
    'home.join.title': '加入我们，与五大业务一起成长',
    'home.join.lead': '我们在南宁、广西及东盟方向持续招聘。',
    'home.join.cta': '查看社会招聘岗位',
    'home.join.contact': '联系我们',

    'about.eyebrow': '集团概况',
    'about.intro.title': '关于集团',
    'about.values.title': '使命、愿景与价值观',
    'about.history.title': '发展历程',
    'about.history.lead': '从 2023 年总部成立起，集团沿着"本地深耕、协同扩展"的路径逐步形成五大业务板块。',
    'about.structure.title': '组织架构',
    'about.structure.lead': '集团总部统一战略、品牌、财务与合规；各业务板块独立运营、独立负责。',
    'about.structure.root': '安迪文化 · 总部',
    'about.banner.credit': '图片：南宁国际会展中心（Wikimedia Commons，CC BY-SA 4.0，EditQ）',

    'eco.eyebrow': '业务生态',
    'eco.title': '五大业务板块',
    'eco.lead': '每家子公司以自己的定位对外发声，同时通过渠道、履约与资源与集团协同。',
    'eco.keywords': '关键词',
    'eco.banner.credit': '图片：南宁城市天际线全景（Wikimedia Commons，CC BY 4.0，MspreilsCN）',

    'ph.eyebrow': '建设中',
    'ph.title': '本页将在下一阶段交付',
    'ph.body': '页面结构与内容清单已在「站点地图与内容清单」中确定，待视觉确认后实现。',

    'skip': '跳到正文',
    'lead.eyebrow': '集团领导',
    'lead.banner': '董事长对集团战略、业务协同与长期责任的看法。',
    'lead.team.title': '领导班子',
    'lead.team.lead': '集团领导班子成员。',
    'lead.portrait': '董事长致辞配图',
    'news.eyebrow': '新闻动态',
    'news.title': '集团与子公司的最新动态',
    'news.lead': '集团层面的决策、各业务的进展与社会责任相关的公告，统一在这里发布。',
    'news.filter.all': '全部',
    'news.filter.group': '集团动态',
    'news.filter.subsidiary': '子公司动态',
    'news.filter.esg': '社会责任',
    'news.empty': '该分类暂无新闻。',
    'news.readMore': '阅读全文',
    'news.back': '返回新闻列表',
    'news.related': '相关新闻',
    'news.notFound': '未找到该新闻，可能已被移除。',
    'esg.eyebrow': 'ESG 与社会责任',
    'esg.title': '对环境、社区与治理负责，并把承诺落到可核验的行动上',
    'esg.lead': '我们把社会责任放在与业务同等的位置。以下为阶段性议题与行动方向，具体指标将随报告分阶段披露。',
    'esg.pillars.title': '三大议题',
    'esg.programs.title': '公益与社区项目',
    'esg.programs.lead': 'ESG 项目持续推进中。',
    'esg.reports.title': '社会责任报告',
    'esg.reports.lead': '报告在编制完成并经董事会审议后发布。',
    'esg.reports.soon': '即将发布',
    'esg.banner.credit': '图片：阳朔漓江与喀斯特山峰（Wikimedia Commons，CC0，Huangdan2060）',
    'ir.eyebrow': '投资者关系',
    'ir.title': '融资条款、财务摘要与股权结构',
    'ir.lead': '收入按全额法确认；政府补助计入其他收益，不计入营业收入。',
    'ir.round.title': '本轮融资',
    'ir.round.target': '目标融资额',
    'ir.round.equity': '拟出让股权',
    'ir.round.pre': '投前估值',
    'ir.round.post': '投后估值',
    'ir.round.instrument': '融资工具',
    'ir.use.title': '资金用途',
    'ir.use.lead': '每笔资金对应可验收的里程碑。',
    'ir.fin.title': '财务摘要',
    'ir.fin.lead': '{year} 年度，合并口径。',
    'ir.fin.revenue': '营业收入',
    'ir.fin.grossMargin': '毛利率',
    'ir.fin.netProfit': '净利润',
    'ir.fin.netMargin': '净利率',
    'ir.fin.otherIncome': '其他收益（政府补助）',
    'ir.fin.grant': '补助占净利润',
    'ir.fin.note': '政府补助计入其他收益，不计入营业收入；税收优惠冲减所得税费用。',
    'ir.cap.title': '股权结构',
    'ir.cap.lead': '股东结构以集团正式股东名册为准。',
    'ir.history.title': '融资历史',
    'ir.history.round': '轮次',
    'ir.history.date': '时间',
    'ir.history.amount': '金额',
    'ir.history.equity': '出让',
    'ir.history.post': '投后估值',
    'ir.contact.title': '投资者联络',
    'ir.contact.lead': '如需获取尽调材料，请通过以下渠道联系投资者关系部门。',
    'careers.eyebrow': '加入我们',
    'careers.title': '在五大业务中找到你的位置',
    'careers.lead': '我们在南宁招聘，也欢迎对东盟业务感兴趣的人才与我们同行。',
    'careers.social.title': '社会招聘',
    'careers.social.lead': '以下岗位持续开放，欢迎投递。',
    'careers.apply': '投递简历',
    'careers.campus.title': '校园招聘',
    'careers.form.title': '简历投递',
    'careers.form.success': '感谢投递。本表单尚未接入招聘系统，投递内容不会被保存。',
    'contact.eyebrow': '联系我们',
    'contact.title': '告诉我们你的需求',
    'contact.lead': '业务咨询、媒体采访、投资者沟通与人才合作，都可以从这里开始。',
    'contact.address': '总部地址',
    'contact.channels': '联系渠道',
    'contact.form.title': '留言与咨询',
    'contact.form.success': '感谢留言。本表单尚未接入后台系统，内容不会被保存。',
    'form.required': '带 * 为必填',
    'form.submit': '提交',
    'form.note': '本表单尚未接入后台系统，提交内容不会被保存或发送；如需即时联系，请使用上方联系方式。',
    'form.select': '请选择',
    'form.name': '姓名',
    'form.phone': '手机号',
    'form.email': '邮箱',
    'form.company': '公司或机构',
    'form.role': '意向岗位',
    'form.direction': '咨询方向',
    'form.message': '留言内容',
    'dir.media': '文化传媒',
    'dir.tech': '科技服务',
    'dir.health': '健康管理',
    'dir.logistics': '物流供应链',
    'dir.invest': '产业投资',
    'dir.ir': '投资者关系',
    'dir.other': '其他',
    'notfound.title': '页面不存在',
    'notfound.body': '该路径未定义。',
  },
  en: {
    'nav.publications': 'Publications',
    'pub.eyebrow': 'Publications',
    'pub.title': 'Group publications',
    'pub.type.letter': 'Annual letter',
    'pub.type.review': 'Year in review',
    'pub.type.esg': 'Responsibility',
    'pub.type.facts': 'Facts and figures',
    'pub.notice': 'This page contains general group-level information and does not constitute investment advice or a performance commitment; statements on finance and policy follow their original documents and final confirmation by the competent authorities.',
    'brand.name': 'Andi Culture',
    'brand.mark': 'ri-building-2-line',
    'brand.home': 'Group portal',
    'nav.about': 'About',
    'nav.leadership': 'Leadership',
    'nav.ecosystem': 'Ecosystem',
    'nav.news': 'News',
    'nav.esg': 'ESG',
    'nav.ir': 'Investor relations',
    'nav.careers': 'Careers',
    'nav.contact': 'Contact',
    'footer.note':
      "Andi Culture’s corporate information platform. Image credits appear under each image.",
    'footer.ecosystem': 'Business ecosystem',
    'footer.site': 'Andi Culture',
    'common.visit': 'Visit',
    'common.more': 'Learn more',
    'common.placeholderVisual': 'Business segment visual',
    'common.imageCredit': 'Image',

    'home.hero.eyebrow': 'Andi Culture · Nanning',
    'home.hero.cta.ecosystem': 'Explore the ecosystem',
    'home.hero.cta.about': 'About the group',
    'home.eco.eyebrow': 'Business ecosystem',
    'home.eco.title': 'Five businesses, one click away',
    'home.eco.lead': 'Each business line has its own website and sections. Select one to enter.',
    'home.about.eyebrow': 'About the group',
    'home.about.title': 'Headquartered in Nanning, connecting five businesses',
    'home.about.more': 'Read the company overview',
    'home.facts.founded': 'Founded',
    'home.facts.capital': 'Registered capital',
    'home.facts.hq': 'Headquarters',
    'home.facts.lines': 'Business lines',
    'home.facts.linesValue': '5',
    'home.news.eyebrow': 'News',
    'home.news.title': 'Latest updates',
    'home.news.all': 'All news',
    'home.esg.eyebrow': 'ESG & social responsibility',
    'home.esg.title': 'Rooted locally, accountable to the environment and communities',
    'home.esg.env': 'Environment',
    'home.esg.env.body': 'Green fulfilment and energy-efficient operations, with key environmental indicators disclosed over time.',
    'home.esg.social': 'Social',
    'home.esg.social.body': 'Serving local clients and partners, supporting talent development and community activities.',
    'home.esg.gov': 'Governance',
    'home.esg.gov.body': 'Each business line is accounted for and run independently; the group sets common compliance and risk controls.',
    'home.esg.cta': 'View ESG topics',
    'home.join.title': 'Join us and grow with our five businesses',
    'home.join.lead': 'We are hiring continuously in Nanning, Guangxi and ASEAN-facing roles.',
    'home.join.cta': 'Open roles',
    'home.join.contact': 'Contact us',

    'about.eyebrow': 'About the group',
    'about.intro.title': 'About us',
    'about.values.title': 'Mission, vision and values',
    'about.history.title': 'Milestones',
    'about.history.lead': 'Since the headquarters was established in 2023, the group has built five business lines along a path of local depth and coordinated expansion.',
    'about.structure.title': 'Structure',
    'about.structure.lead': 'Group headquarters sets strategy, brand, finance and compliance; each business line operates and is accountable on its own.',
    'about.structure.root': 'Andi Culture · Headquarters',
    'about.banner.credit': 'Image: Nanning International Convention and Exhibition Center (Wikimedia Commons, CC BY-SA 4.0, EditQ)',

    'eco.eyebrow': 'Business ecosystem',
    'eco.title': 'Five business lines',
    'eco.lead': 'Each subsidiary speaks for its own positioning, while sharing channels, fulfilment and resources with the group.',
    'eco.keywords': 'Keywords',
    'eco.banner.credit': 'Image: Panoramic skyline of Nanning (Wikimedia Commons, CC BY 4.0, MspreilsCN)',

    'ph.eyebrow': 'In progress',
    'ph.title': 'This page ships in the next phase',
    'ph.body': 'The structure and content inventory are set in the site map. Implementation follows visual sign-off.',

    'skip': 'Skip to content',
    'lead.eyebrow': 'Group leadership',
    'lead.banner': 'The chairman on group strategy, business synergy and long-term responsibility.',
    'lead.team.title': 'Leadership team',
    'lead.team.lead': 'Members of the group leadership team.',
    'lead.portrait': "Chairman's message visual",
    'news.eyebrow': 'News',
    'news.title': 'Latest from the group and its businesses',
    'news.lead': 'Group decisions, business progress and social-responsibility announcements are published here.',
    'news.filter.all': 'All',
    'news.filter.group': 'Group',
    'news.filter.subsidiary': 'Subsidiaries',
    'news.filter.esg': 'ESG',
    'news.empty': 'No items in this category yet.',
    'news.readMore': 'Read more',
    'news.back': 'Back to news',
    'news.related': 'Related news',
    'news.notFound': 'This article could not be found; it may have been removed.',
    'esg.eyebrow': 'ESG & social responsibility',
    'esg.title': 'Accountable for the environment, communities and governance, with commitments that can be verified',
    'esg.lead': 'We treat social responsibility as equal to our business. The focus areas and actions below will be reported against measurable indicators over time.',
    'esg.pillars.title': 'Three focus areas',
    'esg.programs.title': 'Community and public-benefit programmes',
    'esg.programs.lead': 'Our ESG programmes are ongoing.',
    'esg.reports.title': 'Social responsibility reports',
    'esg.reports.lead': 'Reports are published after preparation and board review.',
    'esg.reports.soon': 'Coming soon',
    'esg.banner.credit': 'Image: Li River and karst peaks in Yangshuo (Wikimedia Commons, CC0, Huangdan2060)',
    'ir.eyebrow': 'Investor relations',
    'ir.title': 'Terms, financial summary and shareholding',
    'ir.lead': 'Revenue is recognised on a gross basis; government grants are reported in other income, not revenue.',
    'ir.round.title': 'Current round',
    'ir.round.target': 'Target raise',
    'ir.round.equity': 'Equity offered',
    'ir.round.pre': 'Pre-money valuation',
    'ir.round.post': 'Post-money valuation',
    'ir.round.instrument': 'Instrument',
    'ir.use.title': 'Use of proceeds',
    'ir.use.lead': 'Each use of funds is tied to a verifiable milestone.',
    'ir.fin.title': 'Financial summary',
    'ir.fin.lead': 'FY{year}, consolidated.',
    'ir.fin.revenue': 'Revenue',
    'ir.fin.grossMargin': 'Gross margin',
    'ir.fin.netProfit': 'Net profit',
    'ir.fin.netMargin': 'Net margin',
    'ir.fin.otherIncome': 'Other income (grants)',
    'ir.fin.grant': 'Grants as share of net profit',
    'ir.fin.note': 'Grants go to other income, not revenue; tax relief reduces income tax expense.',
    'ir.cap.title': 'Shareholding',
    'ir.cap.lead': 'Shareholding is governed by the group\'s official shareholder register.',
    'ir.history.title': 'Funding history',
    'ir.history.round': 'Round',
    'ir.history.date': 'Date',
    'ir.history.amount': 'Amount',
    'ir.history.equity': 'Equity',
    'ir.history.post': 'Post-money',
    'ir.contact.title': 'Investor contact',
    'ir.contact.lead': 'For diligence materials, please contact the investor relations team through the channels below.',
    'careers.eyebrow': 'Careers',
    'careers.title': 'Find your place across five businesses',
    'careers.lead': 'We recruit in Nanning and welcome talent interested in our ASEAN-facing work.',
    'careers.social.title': 'Experienced hires',
    'careers.social.lead': 'The following roles are open for application.',
    'careers.apply': 'Apply',
    'careers.campus.title': 'Campus recruitment',
    'careers.form.title': 'Application',
    'careers.form.success': 'Thank you. This form is not yet connected to our recruitment system, so your submission is not stored.',
    'contact.eyebrow': 'Contact',
    'contact.title': 'Tell us what you need',
    'contact.lead': 'Business enquiries, media requests, investor discussions and talent partnerships all start here.',
    'contact.address': 'Headquarters',
    'contact.channels': 'Channels',
    'contact.form.title': 'Enquiry',
    'contact.form.success': 'Thank you. This form is not yet connected to our systems, so your message is not stored.',
    'form.required': '* required',
    'form.submit': 'Submit',
    'form.note': 'This form is not yet connected to our systems, so submissions are neither stored nor sent. For an immediate response, please use the contact details above.',
    'form.select': 'Please select',
    'form.name': 'Name',
    'form.phone': 'Mobile',
    'form.email': 'Email',
    'form.company': 'Company or organisation',
    'form.role': 'Role of interest',
    'form.direction': 'Enquiry about',
    'form.message': 'Message',
    'dir.media': 'Media',
    'dir.tech': 'Technology services',
    'dir.health': 'Health',
    'dir.logistics': 'Logistics',
    'dir.invest': 'Industrial investment',
    'dir.ir': 'Investor relations',
    'dir.other': 'Other',
    'notfound.title': 'Page not found',
    'notfound.body': 'This path is not defined.',
  },
  vi: {
    'nav.publications': 'Ấn phẩm tập đoàn',
    'pub.eyebrow': 'Ấn phẩm tập đoàn',
    'pub.title': 'Ấn phẩm tập đoàn',
    'pub.type.letter': 'Thư thường niên',
    'pub.type.review': 'Nhìn lại năm',
    'pub.type.esg': 'Trách nhiệm xã hội',
    'pub.type.facts': 'Số liệu tổng quan',
    'pub.notice': 'Nội dung trang này là thông tin chung ở cấp tập đoàn, không cấu thành khuyến nghị đầu tư hay cam kết về kết quả kinh doanh; các nội dung liên quan đến tài chính và chính sách được căn cứ theo văn bản gốc và kết quả phê duyệt cuối cùng của cơ quan có thẩm quyền.',
    'brand.name': 'Andi Culture',
    'brand.mark': 'ri-building-2-line',
    'brand.home': 'Cổng thông tin tập đoàn',
    'nav.about': 'Giới thiệu tập đoàn',
    'nav.leadership': 'Thông điệp lãnh đạo',
    'nav.ecosystem': 'Hệ sinh thái kinh doanh',
    'nav.news': 'Tin tức',
    'nav.esg': 'ESG và trách nhiệm xã hội',
    'nav.ir': 'Quan hệ nhà đầu tư',
    'nav.careers': 'Tuyển dụng',
    'nav.contact': 'Liên hệ',
    'footer.note':
      'Nền tảng công bố thông tin đối ngoại của Andi Culture. Nguồn ảnh được ghi dưới mỗi hình.',
    'footer.ecosystem': 'Hệ sinh thái kinh doanh',
    'footer.site': 'Andi Culture',
    'common.visit': 'Truy cập',
    'common.more': 'Tìm hiểu thêm',
    'common.placeholderVisual': 'Hình ảnh lĩnh vực kinh doanh',
    'common.imageCredit': 'Ảnh',

    'home.hero.eyebrow': 'Andi Culture · Nanning',
    'home.hero.cta.ecosystem': 'Khám phá hệ sinh thái kinh doanh',
    'home.hero.cta.about': 'Về tập đoàn',
    'home.eco.eyebrow': 'Hệ sinh thái kinh doanh',
    'home.eco.title': 'Năm lĩnh vực kinh doanh, một cú nhấp chuột',
    'home.eco.lead': 'Mỗi lĩnh vực kinh doanh có website và chuyên mục riêng; chọn để truy cập website tương ứng.',
    'home.about.eyebrow': 'Giới thiệu tập đoàn',
    'home.about.title': 'Trụ sở tại Nanning, kết nối năm lĩnh vực kinh doanh',
    'home.about.more': 'Xem giới thiệu tập đoàn',
    'home.facts.founded': 'Năm thành lập',
    'home.facts.capital': 'Vốn điều lệ',
    'home.facts.hq': 'Trụ sở chính',
    'home.facts.lines': 'Lĩnh vực kinh doanh',
    'home.facts.linesValue': '5',
    'home.news.eyebrow': 'Tin tức',
    'home.news.title': 'Thông tin mới nhất',
    'home.news.all': 'Xem tất cả tin tức',
    'home.esg.eyebrow': 'ESG và trách nhiệm xã hội',
    'home.esg.title': 'Gắn bó với địa phương, có trách nhiệm với môi trường và cộng đồng',
    'home.esg.env': 'Môi trường',
    'home.esg.env.body': 'Chú trọng vận hành xanh và tiết kiệm năng lượng, từng bước công bố các chỉ số môi trường chính.',
    'home.esg.social': 'Xã hội',
    'home.esg.social.body': 'Phục vụ khách hàng và đối tác địa phương, hỗ trợ phát triển nhân lực và hoạt động cộng đồng.',
    'home.esg.gov': 'Quản trị',
    'home.esg.gov.body': 'Mỗi lĩnh vực kinh doanh hạch toán và chịu trách nhiệm độc lập; tập đoàn thống nhất về tuân thủ và quản trị rủi ro.',
    'home.esg.cta': 'Xem các chủ đề ESG',
    'home.join.title': 'Gia nhập cùng chúng tôi và phát triển với năm lĩnh vực kinh doanh',
    'home.join.lead': 'Chúng tôi tuyển dụng liên tục tại Nanning, Quảng Tây và các vị trí hướng tới ASEAN.',
    'home.join.cta': 'Xem vị trí tuyển dụng',
    'home.join.contact': 'Liên hệ với chúng tôi',

    'about.eyebrow': 'Giới thiệu tập đoàn',
    'about.intro.title': 'Về tập đoàn',
    'about.values.title': 'Sứ mệnh, tầm nhìn và giá trị',
    'about.history.title': 'Chặng đường phát triển',
    'about.history.lead': 'Kể từ khi thành lập trụ sở vào năm 2023, tập đoàn đã từng bước hình thành năm lĩnh vực kinh doanh theo định hướng "bám sát địa phương, mở rộng có phối hợp".',
    'about.structure.title': 'Cơ cấu tổ chức',
    'about.structure.lead': 'Trụ sở tập đoàn thống nhất chiến lược, thương hiệu, tài chính và tuân thủ; mỗi lĩnh vực kinh doanh vận hành và tự chịu trách nhiệm.',
    'about.structure.root': 'Andi Culture · Trụ sở chính',
    'about.banner.credit': 'Ảnh: Trung tâm Hội nghị và Triển lãm Quốc tế Nanning (Wikimedia Commons, CC BY-SA 4.0, EditQ)',

    'eco.eyebrow': 'Hệ sinh thái kinh doanh',
    'eco.title': 'Năm lĩnh vực kinh doanh',
    'eco.lead': 'Mỗi công ty con khẳng định vị thế riêng, đồng thời phối hợp với tập đoàn về kênh phân phối, thực hiện đơn hàng và nguồn lực.',
    'eco.keywords': 'Từ khóa',
    'eco.banner.credit': 'Ảnh: Toàn cảnh đường chân trời thành phố Nanning (Wikimedia Commons, CC BY 4.0, MspreilsCN)',

    'ph.eyebrow': 'Đang triển khai',
    'ph.title': 'Trang này sẽ được triển khai ở giai đoạn tiếp theo',
    'ph.body': 'Cấu trúc trang và danh mục nội dung đã được xác định trong "Sơ đồ website và danh mục nội dung", chờ xác nhận thiết kế để triển khai.',

    'skip': 'Chuyển đến nội dung',
    'lead.eyebrow': 'Lãnh đạo tập đoàn',
    'lead.banner': 'Chủ tịch chia sẻ về chiến lược của tập đoàn, sự phối hợp giữa các lĩnh vực kinh doanh và trách nhiệm dài hạn.',
    'lead.team.title': 'Ban lãnh đạo',
    'lead.team.lead': 'Các thành viên ban lãnh đạo tập đoàn.',
    'lead.portrait': 'Hình minh họa thông điệp của Chủ tịch',
    'news.eyebrow': 'Tin tức',
    'news.title': 'Thông tin mới nhất của tập đoàn và các công ty con',
    'news.lead': 'Các quyết định ở cấp tập đoàn, tiến độ của từng lĩnh vực kinh doanh và thông báo về trách nhiệm xã hội được công bố tập trung tại đây.',
    'news.filter.all': 'Tất cả',
    'news.filter.group': 'Tập đoàn',
    'news.filter.subsidiary': 'Công ty con',
    'news.filter.esg': 'Trách nhiệm xã hội',
    'news.empty': 'Chuyên mục này hiện chưa có tin.',
    'news.readMore': 'Đọc toàn văn',
    'news.back': 'Quay lại danh sách tin',
    'news.related': 'Tin liên quan',
    'news.notFound': 'Không tìm thấy tin này, có thể tin đã được gỡ bỏ.',
    'esg.eyebrow': 'ESG và trách nhiệm xã hội',
    'esg.title': 'Có trách nhiệm với môi trường, cộng đồng và quản trị, gắn cam kết với hành động có thể kiểm chứng',
    'esg.lead': 'Chúng tôi đặt trách nhiệm xã hội ngang tầm với hoạt động kinh doanh. Các chủ đề và định hướng hành động dưới đây mang tính giai đoạn; chỉ số cụ thể sẽ được công bố dần theo báo cáo.',
    'esg.pillars.title': 'Ba chủ đề trọng tâm',
    'esg.programs.title': 'Dự án cộng đồng và phúc lợi xã hội',
    'esg.programs.lead': 'Các dự án ESG đang được triển khai liên tục.',
    'esg.reports.title': 'Báo cáo trách nhiệm xã hội',
    'esg.reports.lead': 'Báo cáo được công bố sau khi hoàn tất soạn thảo và được Hội đồng quản trị xem xét.',
    'esg.reports.soon': 'Sắp công bố',
    'esg.banner.credit': 'Ảnh: Sông Ly và các đỉnh núi đá vôi ở Dương Thụy (Wikimedia Commons, CC0, Huangdan2060)',
    'ir.eyebrow': 'Quan hệ nhà đầu tư',
    'ir.title': 'Điều khoản gọi vốn, tóm tắt tài chính và cơ cấu cổ đông',
    'ir.lead': 'Doanh thu được ghi nhận theo phương pháp toàn phần; trợ cấp chính phủ được hạch toán vào thu nhập khác, không tính vào doanh thu.',
    'ir.round.title': 'Vòng gọi vốn hiện tại',
    'ir.round.target': 'Số vốn mục tiêu',
    'ir.round.equity': 'Tỷ lệ cổ phần dự kiến chào bán',
    'ir.round.pre': 'Định giá trước đầu tư',
    'ir.round.post': 'Định giá sau đầu tư',
    'ir.round.instrument': 'Công cụ gọi vốn',
    'ir.use.title': 'Mục đích sử dụng vốn',
    'ir.use.lead': 'Mỗi khoản vốn gắn với một cột mốc có thể nghiệm thu.',
    'ir.fin.title': 'Tóm tắt tài chính',
    'ir.fin.lead': 'Năm {year}, theo phương pháp hợp nhất.',
    'ir.fin.revenue': 'Doanh thu',
    'ir.fin.grossMargin': 'Tỷ suất lợi nhuận gộp',
    'ir.fin.netProfit': 'Lợi nhuận sau thuế',
    'ir.fin.netMargin': 'Tỷ suất lợi nhuận ròng',
    'ir.fin.otherIncome': 'Thu nhập khác (trợ cấp chính phủ)',
    'ir.fin.grant': 'Tỷ trọng trợ cấp trong lợi nhuận sau thuế',
    'ir.fin.note': 'Trợ cấp chính phủ được hạch toán vào thu nhập khác, không tính vào doanh thu; ưu đãi thuế ghi giảm chi phí thuế thu nhập.',
    'ir.cap.title': 'Cơ cấu cổ đông',
    'ir.cap.lead': 'Cơ cấu cổ đông căn cứ theo sổ đăng ký cổ đông chính thức của tập đoàn.',
    'ir.history.title': 'Lịch sử gọi vốn',
    'ir.history.round': 'Vòng',
    'ir.history.date': 'Thời gian',
    'ir.history.amount': 'Số tiền',
    'ir.history.equity': 'Cổ phần chào bán',
    'ir.history.post': 'Sau đầu tư',
    'ir.contact.title': 'Liên hệ nhà đầu tư',
    'ir.contact.lead': 'Để nhận tài liệu thẩm định, vui lòng liên hệ bộ phận quan hệ nhà đầu tư qua các kênh dưới đây.',
    'careers.eyebrow': 'Tuyển dụng',
    'careers.title': 'Tìm vị trí của bạn trong năm lĩnh vực kinh doanh',
    'careers.lead': 'Chúng tôi tuyển dụng tại Nanning và hoan nghênh nhân sự quan tâm đến hoạt động hướng tới ASEAN.',
    'careers.social.title': 'Tuyển dụng nhân sự có kinh nghiệm',
    'careers.social.lead': 'Các vị trí dưới đây đang mở, hoan nghênh ứng tuyển.',
    'careers.apply': 'Gửi hồ sơ',
    'careers.campus.title': 'Tuyển dụng sinh viên',
    'careers.form.title': 'Gửi hồ sơ ứng tuyển',
    'careers.form.success': 'Cảm ơn bạn đã gửi hồ sơ. Biểu mẫu này chưa kết nối với hệ thống tuyển dụng nên nội dung gửi sẽ không được lưu.',
    'contact.eyebrow': 'Liên hệ',
    'contact.title': 'Hãy cho chúng tôi biết nhu cầu của bạn',
    'contact.lead': 'Tư vấn kinh doanh, đề nghị từ truyền thông, trao đổi với nhà đầu tư và hợp tác nhân sự đều có thể bắt đầu từ đây.',
    'contact.address': 'Địa chỉ trụ sở',
    'contact.channels': 'Kênh liên hệ',
    'contact.form.title': 'Gửi tin nhắn và yêu cầu tư vấn',
    'contact.form.success': 'Cảm ơn bạn đã để lại tin nhắn. Biểu mẫu này chưa kết nối với hệ thống nên nội dung sẽ không được lưu.',
    'form.required': 'Mục có dấu * là bắt buộc',
    'form.submit': 'Gửi',
    'form.note': 'Biểu mẫu này chưa kết nối với hệ thống, nội dung gửi sẽ không được lưu hoặc gửi đi; nếu cần liên hệ ngay, vui lòng dùng thông tin liên hệ ở trên.',
    'form.select': 'Vui lòng chọn',
    'form.name': 'Họ và tên',
    'form.phone': 'Số điện thoại',
    'form.email': 'Email',
    'form.company': 'Công ty hoặc tổ chức',
    'form.role': 'Vị trí mong muốn',
    'form.direction': 'Lĩnh vực cần tư vấn',
    'form.message': 'Nội dung tin nhắn',
    'dir.media': 'Truyền thông văn hóa',
    'dir.tech': 'Dịch vụ công nghệ',
    'dir.health': 'Chăm sóc sức khỏe',
    'dir.logistics': 'Logistics và chuỗi cung ứng',
    'dir.invest': 'Đầu tư công nghiệp',
    'dir.ir': 'Quan hệ nhà đầu tư',
    'dir.other': 'Khác',
    'notfound.title': 'Không tìm thấy trang',
    'notfound.body': 'Đường dẫn này không được định nghĩa.',
  },
  th: {
    'nav.publications': 'สิ่งพิมพ์ของกลุ่มบริษัท',
    'pub.eyebrow': 'สิ่งพิมพ์ของกลุ่มบริษัท',
    'pub.title': 'สิ่งพิมพ์ของกลุ่มบริษัท',
    'pub.type.letter': 'จดหมายประจำปี',
    'pub.type.review': 'สรุปภาพรวมปี',
    'pub.type.esg': 'ความรับผิดชอบต่อสังคม',
    'pub.type.facts': 'ข้อมูลและตัวเลขสำคัญ',
    'pub.notice': 'เนื้อหาในหน้านี้เป็นข้อมูลทั่วไปในระดับกลุ่มบริษัท ไม่ถือเป็นคำแนะนำการลงทุนหรือคำมั่นเรื่องผลการดำเนินงาน ข้อความเกี่ยวกับการเงินและนโยบายให้ยึดตามเอกสารต้นฉบับและการพิจารณาขั้นสุดท้ายของหน่วยงานที่มีอำนาจ',
    'brand.name': 'Andi Culture',
    'brand.mark': 'ri-building-2-line',
    'brand.home': 'พอร์ทัลกลุ่มบริษัท',
    'nav.about': 'เกี่ยวกับกลุ่มบริษัท',
    'nav.leadership': 'สารจากผู้บริหาร',
    'nav.ecosystem': 'ระบบธุรกิจ',
    'nav.news': 'ข่าวสาร',
    'nav.esg': 'ESG และความรับผิดชอบต่อสังคม',
    'nav.ir': 'นักลงทุนสัมพันธ์',
    'nav.careers': 'ร่วมงานกับเรา',
    'nav.contact': 'ติดต่อเรา',
    'footer.note':
      'แพลตฟอร์มเผยแพร่ข้อมูลของ Andi Culture เครดิตภาพแสดงอยู่ใต้ภาพแต่ละภาพ',
    'footer.ecosystem': 'ระบบธุรกิจ',
    'footer.site': 'Andi Culture',
    'common.visit': 'เข้าชม',
    'common.more': 'ดูเพิ่มเติม',
    'common.placeholderVisual': 'ภาพประกอบของกลุ่มธุรกิจ',
    'common.imageCredit': 'ภาพ',

    'home.hero.eyebrow': 'Andi Culture · Nanning',
    'home.hero.cta.ecosystem': 'สำรวจระบบธุรกิจ',
    'home.hero.cta.about': 'เกี่ยวกับกลุ่มบริษัท',
    'home.eco.eyebrow': 'ระบบธุรกิจ',
    'home.eco.title': 'ห้าธุรกิจ เข้าถึงได้ในคลิกเดียว',
    'home.eco.lead': 'แต่ละกลุ่มธุรกิจมีเว็บไซต์และหมวดเนื้อหาของตนเอง เลือกเพื่อเข้าสู่เว็บไซต์ที่ต้องการ',
    'home.about.eyebrow': 'เกี่ยวกับกลุ่มบริษัท',
    'home.about.title': 'สำนักงานใหญ่ที่ Nanning เชื่อมห้าธุรกิจ',
    'home.about.more': 'ดูภาพรวมกลุ่มบริษัท',
    'home.facts.founded': 'ปีที่ก่อตั้ง',
    'home.facts.capital': 'ทุนจดทะเบียน',
    'home.facts.hq': 'ที่ตั้งสำนักงานใหญ่',
    'home.facts.lines': 'กลุ่มธุรกิจ',
    'home.facts.linesValue': '5',
    'home.news.eyebrow': 'ข่าวสาร',
    'home.news.title': 'ความเคลื่อนไหวล่าสุด',
    'home.news.all': 'ดูข่าวทั้งหมด',
    'home.esg.eyebrow': 'ESG และความรับผิดชอบต่อสังคม',
    'home.esg.title': 'หยั่งรากในท้องถิ่น รับผิดชอบต่อสิ่งแวดล้อมและชุมชน',
    'home.esg.env': 'สิ่งแวดล้อม',
    'home.esg.env.body': 'มุ่งเน้นการดำเนินงานที่เป็นมิตรต่อสิ่งแวดล้อมและการประหยัดพลังงาน พร้อมเปิดเผยตัวชี้วัดสิ่งแวดล้อมที่สำคัญเป็นระยะ',
    'home.esg.social': 'สังคม',
    'home.esg.social.body': 'ให้บริการลูกค้าและพันธมิตรในท้องถิ่น สนับสนุนการพัฒนาบุคลากรและกิจกรรมของชุมชน',
    'home.esg.gov': 'ธรรมาภิบาล',
    'home.esg.gov.body': 'แต่ละกลุ่มธุรกิจจัดทำบัญชีและรับผิดชอบอย่างอิสระ ส่วนกลุ่มบริษัทกำหนดมาตรฐานการกำกับดูแลและการบริหารความเสี่ยงร่วมกัน',
    'home.esg.cta': 'ดูประเด็น ESG',
    'home.join.title': 'ร่วมงานกับเราและเติบโตไปพร้อมกับห้าธุรกิจ',
    'home.join.lead': 'เรารับสมัครอย่างต่อเนื่องที่ Nanning เขตกว่างซี และตำแหน่งที่มุ่งสู่อาเซียน',
    'home.join.cta': 'ดูตำแหน่งงาน',
    'home.join.contact': 'ติดต่อเรา',

    'about.eyebrow': 'เกี่ยวกับกลุ่มบริษัท',
    'about.intro.title': 'เกี่ยวกับเรา',
    'about.values.title': 'พันธกิจ วิสัยทัศน์ และค่านิยม',
    'about.history.title': 'เส้นทางการเติบโต',
    'about.history.lead': 'นับจากการจัดตั้งสำนักงานใหญ่ในปี 2023 กลุ่มบริษัทได้ก่อรูปห้ากลุ่มธุรกิจตามแนวทาง "หยั่งรากในท้องถิ่น ขยายตัวอย่างประสานกัน"',
    'about.structure.title': 'โครงสร้างองค์กร',
    'about.structure.lead': 'สำนักงานใหญ่กำหนดกลยุทธ์ แบรนด์ การเงิน และการกำกับดูแลร่วมกัน ส่วนแต่ละกลุ่มธุรกิจดำเนินงานและรับผิดชอบด้วยตนเอง',
    'about.structure.root': 'Andi Culture · สำนักงานใหญ่',
    'about.banner.credit': 'ภาพ: ศูนย์การประชุมและนิทรรศการนานาชาติหนานหนิง (Wikimedia Commons, CC BY-SA 4.0, EditQ)',

    'eco.eyebrow': 'ระบบธุรกิจ',
    'eco.title': 'ห้ากลุ่มธุรกิจ',
    'eco.lead': 'บริษัทย่อยแต่ละแห่งสื่อสารจุดยืนของตนเอง พร้อมประสานกับกลุ่มบริษัทด้านช่องทาง การส่งมอบ และทรัพยากร',
    'eco.keywords': 'คำสำคัญ',
    'eco.banner.credit': 'ภาพ: ทิวทัศน์เส้นขอบฟ้าเมืองหนานหนิงแบบพาโนรามา (Wikimedia Commons, CC BY 4.0, MspreilsCN)',

    'ph.eyebrow': 'อยู่ระหว่างดำเนินการ',
    'ph.title': 'หน้านี้จะเปิดให้ใช้งานในระยะถัดไป',
    'ph.body': 'โครงสร้างหน้าและรายการเนื้อหาได้กำหนดไว้ใน "แผนผังเว็บไซต์และรายการเนื้อหา" แล้ว โดยรอการยืนยันงานออกแบบก่อนพัฒนา',

    'skip': 'ข้ามไปยังเนื้อหา',
    'lead.eyebrow': 'ผู้บริหารกลุ่มบริษัท',
    'lead.banner': 'ประธานกล่าวถึงกลยุทธ์ของกลุ่มบริษัท การประสานงานระหว่างธุรกิจ และความรับผิดชอบในระยะยาว',
    'lead.team.title': 'คณะผู้บริหาร',
    'lead.team.lead': 'สมาชิกคณะผู้บริหารของกลุ่มบริษัท',
    'lead.portrait': 'ภาพประกอบสารจากประธาน',
    'news.eyebrow': 'ข่าวสาร',
    'news.title': 'ความเคลื่อนไหวล่าสุดของกลุ่มบริษัทและบริษัทย่อย',
    'news.lead': 'มติในระดับกลุ่มบริษัท ความคืบหน้าของแต่ละธุรกิจ และประกาศด้านความรับผิดชอบต่อสังคม เผยแพร่รวมไว้ที่นี่',
    'news.filter.all': 'ทั้งหมด',
    'news.filter.group': 'กลุ่มบริษัท',
    'news.filter.subsidiary': 'บริษัทย่อย',
    'news.filter.esg': 'ความรับผิดชอบต่อสังคม',
    'news.empty': 'ยังไม่มีข่าวในหมวดนี้',
    'news.readMore': 'อ่านฉบับเต็ม',
    'news.back': 'กลับไปยังรายการข่าว',
    'news.related': 'ข่าวที่เกี่ยวข้อง',
    'news.notFound': 'ไม่พบข่าวนี้ อาจถูกลบออกไปแล้ว',
    'esg.eyebrow': 'ESG และความรับผิดชอบต่อสังคม',
    'esg.title': 'รับผิดชอบต่อสิ่งแวดล้อม ชุมชน และธรรมาภิบาล พร้อมแปลงคำมั่นให้เป็นแนวปฏิบัติที่ตรวจสอบได้',
    'esg.lead': 'เราจัดให้ความรับผิดชอบต่อสังคมมีความสำคัญเทียบเท่าการดำเนินธุรกิจ ประเด็นและแนวทางปฏิบัติด้านล่างเป็นระยะเริ่มต้น โดยตัวชี้วัดจะเปิดเผยเป็นระยะตามรายงาน',
    'esg.pillars.title': 'สามประเด็นหลัก',
    'esg.programs.title': 'โครงการสาธารณประโยชน์และชุมชน',
    'esg.programs.lead': 'โครงการ ESG ของเราดำเนินอย่างต่อเนื่อง',
    'esg.reports.title': 'รายงานความรับผิดชอบต่อสังคม',
    'esg.reports.lead': 'รายงานจะเผยแพร่หลังจากจัดทำเสร็จและผ่านการพิจารณาของคณะกรรมการ',
    'esg.reports.soon': 'จะเผยแพร่เร็ว ๆ นี้',
    'esg.banner.credit': 'ภาพ: แม่น้ำหลีและภูเขาหินปูนในหยางซั่ว (Wikimedia Commons, CC0, Huangdan2060)',
    'ir.eyebrow': 'นักลงทุนสัมพันธ์',
    'ir.title': 'เงื่อนไขการระดมทุน สรุปทางการเงิน และโครงสร้างผู้ถือหุ้น',
    'ir.lead': 'รับรู้รายได้ตามวิธีเต็มจำนวน เงินอุดหนุนจากรัฐบันทึกเป็นรายได้อื่น ไม่นับเป็นรายได้จากการดำเนินงาน',
    'ir.round.title': 'การระดมทุนรอบปัจจุบัน',
    'ir.round.target': 'เป้าหมายวงเงินระดมทุน',
    'ir.round.equity': 'สัดส่วนหุ้นที่เสนอขาย',
    'ir.round.pre': 'มูลค่าก่อนการลงทุน',
    'ir.round.post': 'มูลค่าหลังการลงทุน',
    'ir.round.instrument': 'เครื่องมือระดมทุน',
    'ir.use.title': 'การใช้เงินที่ระดมได้',
    'ir.use.lead': 'เงินทุนแต่ละส่วนผูกกับหมุดหมายที่ตรวจรับได้',
    'ir.fin.title': 'สรุปทางการเงิน',
    'ir.fin.lead': 'ปี {year} แบบรวมกลุ่ม',
    'ir.fin.revenue': 'รายได้จากการดำเนินงาน',
    'ir.fin.grossMargin': 'อัตรากำไรขั้นต้น',
    'ir.fin.netProfit': 'กำไรสุทธิ',
    'ir.fin.netMargin': 'อัตรากำไรสุทธิ',
    'ir.fin.otherIncome': 'รายได้อื่น (เงินอุดหนุนจากรัฐ)',
    'ir.fin.grant': 'สัดส่วนเงินอุดหนุนต่อกำไรสุทธิ',
    'ir.fin.note': 'เงินอุดหนุนจากรัฐบันทึกเป็นรายได้อื่น ไม่นับเป็นรายได้จากการดำเนินงาน ส่วนสิทธิประโยชน์ทางภาษีหักลดค่าใช้จ่ายภาษีเงินได้',
    'ir.cap.title': 'โครงสร้างผู้ถือหุ้น',
    'ir.cap.lead': 'โครงสร้างผู้ถือหุ้นยึดตามสมุดทะเบียนผู้ถือหุ้นอย่างเป็นทางการของกลุ่มบริษัท',
    'ir.history.title': 'ประวัติการระดมทุน',
    'ir.history.round': 'รอบ',
    'ir.history.date': 'วันที่',
    'ir.history.amount': 'จำนวนเงิน',
    'ir.history.equity': 'หุ้นที่เสนอขาย',
    'ir.history.post': 'หลังการลงทุน',
    'ir.contact.title': 'ติดต่อนักลงทุนสัมพันธ์',
    'ir.contact.lead': 'หากต้องการเอกสารตรวจสอบสถานะ (due diligence) กรุณาติดต่อฝ่ายนักลงทุนสัมพันธ์ผ่านช่องทางด้านล่าง',
    'careers.eyebrow': 'ร่วมงานกับเรา',
    'careers.title': 'ค้นหาตำแหน่งของคุณในห้าธุรกิจ',
    'careers.lead': 'เรารับสมัครงานที่ Nanning และยินดีต้อนรับผู้ที่สนใจงานด้านอาเซียน',
    'careers.social.title': 'ตำแหน่งงานสำหรับผู้มีประสบการณ์',
    'careers.social.lead': 'ตำแหน่งต่อไปนี้เปิดรับอย่างต่อเนื่อง ยินดีรับใบสมัคร',
    'careers.apply': 'ส่งใบสมัคร',
    'careers.campus.title': 'การรับสมัครนักศึกษา',
    'careers.form.title': 'ส่งใบสมัครงาน',
    'careers.form.success': 'ขอบคุณสำหรับการสมัคร แบบฟอร์มนี้ยังไม่ได้เชื่อมต่อกับระบบรับสมัครงาน ข้อมูลที่ส่งจะไม่ถูกบันทึก',
    'contact.eyebrow': 'ติดต่อเรา',
    'contact.title': 'บอกความต้องการของคุณให้เราทราบ',
    'contact.lead': 'การสอบถามด้านธุรกิจ การขอข้อมูลจากสื่อ การหารือกับนักลงทุน และความร่วมมือด้านบุคลากร เริ่มต้นได้ที่นี่',
    'contact.address': 'ที่อยู่สำนักงานใหญ่',
    'contact.channels': 'ช่องทางติดต่อ',
    'contact.form.title': 'ฝากข้อความและสอบถาม',
    'contact.form.success': 'ขอบคุณสำหรับข้อความ แบบฟอร์มนี้ยังไม่ได้เชื่อมต่อกับระบบ ข้อมูลจะไม่ถูกบันทึก',
    'form.required': 'ช่องที่มี * จำเป็นต้องกรอก',
    'form.submit': 'ส่ง',
    'form.note': 'แบบฟอร์มนี้ยังไม่ได้เชื่อมต่อกับระบบ ข้อมูลที่ส่งจะไม่ถูกบันทึกหรือส่งออก หากต้องการติดต่อทันที กรุณาใช้ช่องทางติดต่อด้านบน',
    'form.select': 'กรุณาเลือก',
    'form.name': 'ชื่อ-นามสกุล',
    'form.phone': 'หมายเลขโทรศัพท์',
    'form.email': 'อีเมล',
    'form.company': 'บริษัทหรือหน่วยงาน',
    'form.role': 'ตำแหน่งที่สนใจ',
    'form.direction': 'หัวข้อที่ต้องการสอบถาม',
    'form.message': 'รายละเอียดข้อความ',
    'dir.media': 'สื่อและวัฒนธรรม',
    'dir.tech': 'บริการเทคโนโลยี',
    'dir.health': 'การดูแลสุขภาพ',
    'dir.logistics': 'โลจิสติกส์และห่วงโซ่อุปทาน',
    'dir.invest': 'การลงทุนอุตสาหกรรม',
    'dir.ir': 'นักลงทุนสัมพันธ์',
    'dir.other': 'อื่น ๆ',
    'notfound.title': 'ไม่พบหน้าเว็บ',
    'notfound.body': 'ไม่พบเส้นทางนี้ในระบบ',
  },
  id: {
    'nav.publications': 'Publikasi grup',
    'pub.eyebrow': 'Publikasi grup',
    'pub.title': 'Publikasi grup',
    'pub.type.letter': 'Surat tahunan',
    'pub.type.review': 'Tinjauan tahunan',
    'pub.type.esg': 'Tanggung jawab sosial',
    'pub.type.facts': 'Data dan angka',
    'pub.notice': 'Isi halaman ini merupakan informasi umum di tingkat grup dan bukan merupakan saran investasi atau komitmen atas kinerja; pernyataan mengenai keuangan dan kebijakan mengacu pada dokumen aslinya serta penetapan akhir dari instansi yang berwenang.',
    'brand.name': 'Andi Culture',
    'brand.mark': 'ri-building-2-line',
    'brand.home': 'Portal grup',
    'nav.about': 'Tentang grup',
    'nav.leadership': 'Pesan pimpinan',
    'nav.ecosystem': 'Ekosistem bisnis',
    'nav.news': 'Berita',
    'nav.esg': 'ESG dan tanggung jawab sosial',
    'nav.ir': 'Hubungan investor',
    'nav.careers': 'Karier',
    'nav.contact': 'Kontak',
    'footer.note':
      'Platform publikasi informasi Andi Culture. Kredit gambar tercantum di bawah setiap gambar.',
    'footer.ecosystem': 'Ekosistem bisnis',
    'footer.site': 'Andi Culture',
    'common.visit': 'Kunjungi',
    'common.more': 'Selengkapnya',
    'common.placeholderVisual': 'Visual lini bisnis',
    'common.imageCredit': 'Gambar',

    'home.hero.eyebrow': 'Andi Culture · Nanning',
    'home.hero.cta.ecosystem': 'Jelajahi ekosistem bisnis',
    'home.hero.cta.about': 'Tentang grup',
    'home.eco.eyebrow': 'Ekosistem bisnis',
    'home.eco.title': 'Lima lini bisnis, satu klik',
    'home.eco.lead': 'Setiap lini bisnis memiliki situs web dan bagiannya sendiri. Pilih salah satu untuk masuk.',
    'home.about.eyebrow': 'Tentang grup',
    'home.about.title': 'Berkantor pusat di Nanning, menghubungkan lima lini bisnis',
    'home.about.more': 'Lihat profil grup',
    'home.facts.founded': 'Tahun berdiri',
    'home.facts.capital': 'Modal dasar',
    'home.facts.hq': 'Kantor pusat',
    'home.facts.lines': 'Lini bisnis',
    'home.facts.linesValue': '5',
    'home.news.eyebrow': 'Berita',
    'home.news.title': 'Perkembangan terbaru',
    'home.news.all': 'Lihat semua berita',
    'home.esg.eyebrow': 'ESG dan tanggung jawab sosial',
    'home.esg.title': 'Berakar di daerah, bertanggung jawab kepada lingkungan dan masyarakat',
    'home.esg.env': 'Lingkungan',
    'home.esg.env.body': 'Mengutamakan operasional ramah lingkungan dan hemat energi, dengan indikator lingkungan utama diungkapkan secara bertahap.',
    'home.esg.social': 'Sosial',
    'home.esg.social.body': 'Melayani klien dan mitra lokal, serta mendukung pengembangan talenta dan kegiatan masyarakat.',
    'home.esg.gov': 'Tata kelola',
    'home.esg.gov.body': 'Setiap lini bisnis melakukan pembukuan dan bertanggung jawab secara mandiri; grup menetapkan kepatuhan dan pengendalian risiko secara bersama.',
    'home.esg.cta': 'Lihat topik ESG',
    'home.join.title': 'Bergabunglah dan tumbuh bersama lima lini bisnis kami',
    'home.join.lead': 'Kami merekrut secara berkelanjutan di Nanning, Guangxi, dan posisi yang berorientasi ASEAN.',
    'home.join.cta': 'Lihat lowongan',
    'home.join.contact': 'Hubungi kami',

    'about.eyebrow': 'Tentang grup',
    'about.intro.title': 'Tentang kami',
    'about.values.title': 'Misi, visi, dan nilai',
    'about.history.title': 'Perjalanan perkembangan',
    'about.history.lead': 'Sejak kantor pusat berdiri pada 2023, grup ini secara bertahap membentuk lima lini bisnis dengan pendekatan "mendalami daerah, berkembang secara terkoordinasi".',
    'about.structure.title': 'Struktur organisasi',
    'about.structure.lead': 'Kantor pusat grup menetapkan strategi, merek, keuangan, dan kepatuhan; setiap lini bisnis beroperasi dan bertanggung jawab sendiri.',
    'about.structure.root': 'Andi Culture · Kantor pusat',
    'about.banner.credit': 'Gambar: Nanning International Convention and Exhibition Center (Wikimedia Commons, CC BY-SA 4.0, EditQ)',

    'eco.eyebrow': 'Ekosistem bisnis',
    'eco.title': 'Lima lini bisnis',
    'eco.lead': 'Setiap anak perusahaan menyampaikan posisinya sendiri, sekaligus bersinergi dengan grup dalam hal saluran, pemenuhan pesanan, dan sumber daya.',
    'eco.keywords': 'Kata kunci',
    'eco.banner.credit': 'Gambar: Panorama cakrawala Kota Nanning (Wikimedia Commons, CC BY 4.0, MspreilsCN)',

    'ph.eyebrow': 'Dalam pengerjaan',
    'ph.title': 'Halaman ini akan dirilis pada tahap berikutnya',
    'ph.body': 'Struktur halaman dan daftar isi telah ditetapkan dalam "Peta situs dan daftar isi"; implementasi menunggu persetujuan desain.',

    'skip': 'Lompat ke konten',
    'lead.eyebrow': 'Pimpinan grup',
    'lead.banner': 'Pandangan ketua mengenai strategi grup, sinergi bisnis, dan tanggung jawab jangka panjang.',
    'lead.team.title': 'Jajaran pimpinan',
    'lead.team.lead': 'Anggota jajaran pimpinan grup.',
    'lead.portrait': 'Visual pesan ketua',
    'news.eyebrow': 'Berita',
    'news.title': 'Perkembangan terbaru grup dan anak perusahaan',
    'news.lead': 'Keputusan di tingkat grup, kemajuan setiap lini bisnis, dan pengumuman tanggung jawab sosial diterbitkan secara terpusat di sini.',
    'news.filter.all': 'Semua',
    'news.filter.group': 'Grup',
    'news.filter.subsidiary': 'Anak perusahaan',
    'news.filter.esg': 'Tanggung jawab sosial',
    'news.empty': 'Belum ada berita pada kategori ini.',
    'news.readMore': 'Baca selengkapnya',
    'news.back': 'Kembali ke daftar berita',
    'news.related': 'Berita terkait',
    'news.notFound': 'Berita ini tidak ditemukan dan mungkin telah dihapus.',
    'esg.eyebrow': 'ESG dan tanggung jawab sosial',
    'esg.title': 'Bertanggung jawab atas lingkungan, masyarakat, dan tata kelola, dengan komitmen yang dapat diverifikasi',
    'esg.lead': 'Kami menempatkan tanggung jawab sosial setara dengan kegiatan bisnis. Topik dan arah tindakan di bawah ini bersifat bertahap; indikator rincinya akan diungkapkan secara bertahap melalui laporan.',
    'esg.pillars.title': 'Tiga topik utama',
    'esg.programs.title': 'Program sosial dan kemasyarakatan',
    'esg.programs.lead': 'Program ESG kami terus berjalan.',
    'esg.reports.title': 'Laporan tanggung jawab sosial',
    'esg.reports.lead': 'Laporan diterbitkan setelah penyusunan selesai dan ditinjau oleh dewan.',
    'esg.reports.soon': 'Segera terbit',
    'esg.banner.credit': 'Gambar: Sungai Li dan puncak karst di Yangshuo (Wikimedia Commons, CC0, Huangdan2060)',
    'ir.eyebrow': 'Hubungan investor',
    'ir.title': 'Ketentuan pendanaan, ringkasan keuangan, dan komposisi pemegang saham',
    'ir.lead': 'Pendapatan diakui dengan metode penuh; hibah pemerintah dicatat sebagai pendapatan lain dan tidak dihitung sebagai pendapatan usaha.',
    'ir.round.title': 'Putaran pendanaan saat ini',
    'ir.round.target': 'Target dana yang dihimpun',
    'ir.round.equity': 'Saham yang akan ditawarkan',
    'ir.round.pre': 'Valuasi sebelum investasi',
    'ir.round.post': 'Valuasi setelah investasi',
    'ir.round.instrument': 'Instrumen pendanaan',
    'ir.use.title': 'Penggunaan dana',
    'ir.use.lead': 'Setiap penggunaan dana terkait dengan tonggak yang dapat diverifikasi.',
    'ir.fin.title': 'Ringkasan keuangan',
    'ir.fin.lead': 'Tahun {year}, konsolidasian.',
    'ir.fin.revenue': 'Pendapatan usaha',
    'ir.fin.grossMargin': 'Marjin laba bruto',
    'ir.fin.netProfit': 'Laba bersih',
    'ir.fin.netMargin': 'Marjin laba bersih',
    'ir.fin.otherIncome': 'Pendapatan lain (hibah pemerintah)',
    'ir.fin.grant': 'Porsi hibah terhadap laba bersih',
    'ir.fin.note': 'Hibah pemerintah dicatat sebagai pendapatan lain dan tidak dihitung sebagai pendapatan usaha; insentif pajak mengurangi beban pajak penghasilan.',
    'ir.cap.title': 'Komposisi pemegang saham',
    'ir.cap.lead': 'Komposisi pemegang saham mengacu pada daftar pemegang saham resmi grup.',
    'ir.history.title': 'Riwayat pendanaan',
    'ir.history.round': 'Putaran',
    'ir.history.date': 'Tanggal',
    'ir.history.amount': 'Jumlah',
    'ir.history.equity': 'Saham',
    'ir.history.post': 'Setelah investasi',
    'ir.contact.title': 'Kontak investor',
    'ir.contact.lead': 'Untuk memperoleh materi uji tuntas, silakan menghubungi tim hubungan investor melalui saluran di bawah ini.',
    'careers.eyebrow': 'Karier',
    'careers.title': 'Temukan posisi Anda di lima lini bisnis',
    'careers.lead': 'Kami merekrut di Nanning dan menyambut talenta yang tertarik pada kegiatan kami yang berorientasi ASEAN.',
    'careers.social.title': 'Rekrutmen tenaga berpengalaman',
    'careers.social.lead': 'Posisi berikut terbuka untuk dilamar.',
    'careers.apply': 'Lamar',
    'careers.campus.title': 'Rekrutmen kampus',
    'careers.form.title': 'Lamaran',
    'careers.form.success': 'Terima kasih atas lamaran Anda. Formulir ini belum terhubung ke sistem rekrutmen kami, sehingga kiriman Anda tidak disimpan.',
    'contact.eyebrow': 'Kontak',
    'contact.title': 'Sampaikan kebutuhan Anda',
    'contact.lead': 'Pertanyaan bisnis, permintaan media, diskusi dengan investor, dan kerja sama talenta semuanya dimulai di sini.',
    'contact.address': 'Alamat kantor pusat',
    'contact.channels': 'Saluran kontak',
    'contact.form.title': 'Pesan dan pertanyaan',
    'contact.form.success': 'Terima kasih atas pesan Anda. Formulir ini belum terhubung ke sistem kami, sehingga pesan Anda tidak disimpan.',
    'form.required': '* wajib diisi',
    'form.submit': 'Kirim',
    'form.note': 'Formulir ini belum terhubung ke sistem kami, sehingga kiriman tidak disimpan maupun dikirim. Untuk respons cepat, silakan gunakan detail kontak di atas.',
    'form.select': 'Silakan pilih',
    'form.name': 'Nama',
    'form.phone': 'Nomor ponsel',
    'form.email': 'Email',
    'form.company': 'Perusahaan atau organisasi',
    'form.role': 'Posisi yang diminati',
    'form.direction': 'Topik pertanyaan',
    'form.message': 'Pesan',
    'dir.media': 'Media',
    'dir.tech': 'Layanan teknologi',
    'dir.health': 'Kesehatan',
    'dir.logistics': 'Logistik',
    'dir.invest': 'Investasi industri',
    'dir.ir': 'Hubungan investor',
    'dir.other': 'Lainnya',
    'notfound.title': 'Halaman tidak ditemukan',
    'notfound.body': 'Jalur ini tidak terdefinisi.',
  },
  ms: {
    'nav.publications': 'Publikasi kumpulan',
    'pub.eyebrow': 'Publikasi kumpulan',
    'pub.title': 'Publikasi kumpulan',
    'pub.type.letter': 'Surat tahunan',
    'pub.type.review': 'Tinjauan tahun',
    'pub.type.esg': 'Tanggungjawab sosial',
    'pub.type.facts': 'Fakta dan angka',
    'pub.notice': 'Kandungan halaman ini ialah maklumat umum di peringkat kumpulan dan bukan nasihat pelaburan atau komitmen prestasi; penyataan mengenai kewangan dan dasar berpandukan dokumen asalnya serta penetapan muktamad oleh pihak berkuasa yang berkenaan.',
    'brand.name': 'Andi Culture',
    'brand.mark': 'ri-building-2-line',
    'brand.home': 'Portal kumpulan',
    'nav.about': 'Tentang kumpulan',
    'nav.leadership': 'Kepimpinan',
    'nav.ecosystem': 'Ekosistem',
    'nav.news': 'Berita',
    'nav.esg': 'ESG',
    'nav.ir': 'Hubungan pelabur',
    'nav.careers': 'Kerjaya',
    'nav.contact': 'Hubungi',
    'footer.note':
      'Platform maklumat korporat Andi Culture. Kredit imej dipaparkan di bawah setiap imej.',
    'footer.ecosystem': 'Ekosistem perniagaan',
    'footer.site': 'Andi Culture',
    'common.visit': 'Lawati',
    'common.more': 'Ketahui lebih lanjut',
    'common.placeholderVisual': 'Visual segmen perniagaan',
    'common.imageCredit': 'Imej',

    'home.hero.eyebrow': 'Andi Culture · Nanning',
    'home.hero.cta.ecosystem': 'Terokai ekosistem perniagaan',
    'home.hero.cta.about': 'Tentang kumpulan',
    'home.eco.eyebrow': 'Ekosistem perniagaan',
    'home.eco.title': 'Lima perniagaan, satu klik sahaja',
    'home.eco.lead': 'Setiap barisan perniagaan mempunyai laman web dan seksyen tersendiri. Pilih satu untuk masuk.',
    'home.about.eyebrow': 'Tentang kumpulan',
    'home.about.title': 'Beribu pejabat di Nanning, menghubungkan lima perniagaan',
    'home.about.more': 'Lihat profil kumpulan',
    'home.facts.founded': 'Ditubuhkan',
    'home.facts.capital': 'Modal berdaftar',
    'home.facts.hq': 'Ibu pejabat',
    'home.facts.lines': 'Barisan perniagaan',
    'home.facts.linesValue': '5',
    'home.news.eyebrow': 'Berita',
    'home.news.title': 'Perkembangan terkini',
    'home.news.all': 'Semua berita',
    'home.esg.eyebrow': 'ESG dan tanggungjawab sosial',
    'home.esg.title': 'Berakar di peringkat tempatan, bertanggungjawab terhadap alam sekitar dan komuniti',
    'home.esg.env': 'Alam sekitar',
    'home.esg.env.body': 'Menumpukan pemenuhan pesanan yang hijau dan operasi cekap tenaga, dengan petunjuk alam sekitar utama diumumkan dari semasa ke semasa.',
    'home.esg.social': 'Sosial',
    'home.esg.social.body': 'Berkhidmat kepada pelanggan dan rakan kongsi tempatan, serta menyokong pembangunan bakat dan aktiviti komuniti.',
    'home.esg.gov': 'Tadbir urus',
    'home.esg.gov.body': 'Setiap barisan perniagaan diakaun dan diurus secara bebas; kumpulan menetapkan pematuhan dan kawalan risiko yang seragam.',
    'home.esg.cta': 'Lihat topik ESG',
    'home.join.title': 'Sertai kami dan berkembang bersama lima perniagaan kami',
    'home.join.lead': 'Kami mengupah secara berterusan di Nanning, Guangxi dan bagi peranan yang menyasarkan ASEAN.',
    'home.join.cta': 'Jawatan terbuka',
    'home.join.contact': 'Hubungi kami',

    'about.eyebrow': 'Tentang kumpulan',
    'about.intro.title': 'Tentang kami',
    'about.values.title': 'Misi, visi dan nilai',
    'about.history.title': 'Peristiwa penting',
    'about.history.lead': 'Sejak ibu pejabat ditubuhkan pada 2023, kumpulan ini telah membina lima barisan perniagaan mengikut pendekatan mendalami peringkat tempatan dan berkembang secara terkoordinasi.',
    'about.structure.title': 'Struktur',
    'about.structure.lead': 'Ibu pejabat kumpulan menetapkan strategi, jenama, kewangan dan pematuhan; setiap barisan perniagaan beroperasi dan bertanggungjawab secara sendiri.',
    'about.structure.root': 'Andi Culture · Ibu pejabat',
    'about.banner.credit': 'Imej: Nanning International Convention and Exhibition Center (Wikimedia Commons, CC BY-SA 4.0, EditQ)',

    'eco.eyebrow': 'Ekosistem perniagaan',
    'eco.title': 'Lima barisan perniagaan',
    'eco.lead': 'Setiap anak syarikat menyuarakan kedudukannya sendiri, sambil berkongsi saluran, pemenuhan pesanan dan sumber dengan kumpulan.',
    'eco.keywords': 'Kata kunci',
    'eco.banner.credit': 'Imej: Panorama garis langit bandar Nanning (Wikimedia Commons, CC BY 4.0, MspreilsCN)',

    'ph.eyebrow': 'Sedang dilaksanakan',
    'ph.title': 'Halaman ini akan tersedia pada fasa seterusnya',
    'ph.body': 'Struktur halaman dan senarai kandungan telah ditetapkan dalam peta laman. Pelaksanaan menyusuli kelulusan reka bentuk.',

    'skip': 'Langkau ke kandungan',
    'lead.eyebrow': 'Kepimpinan kumpulan',
    'lead.banner': 'Pengerusi mengenai strategi kumpulan, sinergi perniagaan dan tanggungjawab jangka panjang.',
    'lead.team.title': 'Pasukan kepimpinan',
    'lead.team.lead': 'Ahli pasukan kepimpinan kumpulan.',
    'lead.portrait': 'Visual pesanan pengerusi',
    'news.eyebrow': 'Berita',
    'news.title': 'Perkembangan terkini kumpulan dan perniagaannya',
    'news.lead': 'Keputusan kumpulan, kemajuan perniagaan dan pengumuman tanggungjawab sosial diterbitkan di sini.',
    'news.filter.all': 'Semua',
    'news.filter.group': 'Kumpulan',
    'news.filter.subsidiary': 'Anak syarikat',
    'news.filter.esg': 'ESG',
    'news.empty': 'Belum ada item dalam kategori ini.',
    'news.readMore': 'Baca selanjutnya',
    'news.back': 'Kembali ke berita',
    'news.related': 'Berita berkaitan',
    'news.notFound': 'Artikel ini tidak ditemui; ia mungkin telah dialih keluar.',
    'esg.eyebrow': 'ESG dan tanggungjawab sosial',
    'esg.title': 'Bertanggungjawab terhadap alam sekitar, komuniti dan tadbir urus, dengan komitmen yang boleh disahkan',
    'esg.lead': 'Kami menganggap tanggungjawab sosial setara dengan perniagaan kami. Bidang tumpuan dan tindakan di bawah bersifat berperingkat; petunjuk khusus akan dilaporkan dari semasa ke semasa.',
    'esg.pillars.title': 'Tiga bidang tumpuan',
    'esg.programs.title': 'Program komuniti dan manfaat awam',
    'esg.programs.lead': 'Program ESG kami sedang berjalan.',
    'esg.reports.title': 'Laporan tanggungjawab sosial',
    'esg.reports.lead': 'Laporan diterbitkan selepas penyediaan selesai dan semakan lembaga pengarah.',
    'esg.reports.soon': 'Akan datang',
    'esg.banner.credit': 'Imej: Sungai Li dan puncak karst di Yangshuo (Wikimedia Commons, CC0, Huangdan2060)',
    'ir.eyebrow': 'Hubungan pelabur',
    'ir.title': 'Terma, ringkasan kewangan dan pegangan saham',
    'ir.lead': 'Hasil diiktiraf mengikut kaedah penuh; geran kerajaan dilaporkan dalam pendapatan lain, bukan hasil.',
    'ir.round.title': 'Pusingan semasa',
    'ir.round.target': 'Sasaran kutipan',
    'ir.round.equity': 'Ekuiti yang ditawarkan',
    'ir.round.pre': 'Penilaian sebelum pelaburan',
    'ir.round.post': 'Penilaian selepas pelaburan',
    'ir.round.instrument': 'Instrumen',
    'ir.use.title': 'Penggunaan hasil',
    'ir.use.lead': 'Setiap penggunaan dana terikat pada pencapaian yang boleh disahkan.',
    'ir.fin.title': 'Ringkasan kewangan',
    'ir.fin.lead': 'TK{year}, disatukan.',
    'ir.fin.revenue': 'Hasil',
    'ir.fin.grossMargin': 'Margin kasar',
    'ir.fin.netProfit': 'Untung bersih',
    'ir.fin.netMargin': 'Margin bersih',
    'ir.fin.otherIncome': 'Pendapatan lain (geran kerajaan)',
    'ir.fin.grant': 'Geran sebagai bahagian untung bersih',
    'ir.fin.note': 'Geran kerajaan dimasukkan ke pendapatan lain, bukan hasil; pelepasan cukai mengurangkan belanja cukai pendapatan.',
    'ir.cap.title': 'Pegangan saham',
    'ir.cap.lead': 'Pegangan saham berpandukan daftar pemegang saham rasmi kumpulan.',
    'ir.history.title': 'Sejarah pembiayaan',
    'ir.history.round': 'Pusingan',
    'ir.history.date': 'Tarikh',
    'ir.history.amount': 'Jumlah',
    'ir.history.equity': 'Ekuiti',
    'ir.history.post': 'Selepas pelaburan',
    'ir.contact.title': 'Hubungan pelabur',
    'ir.contact.lead': 'Untuk bahan uji tuntas, sila hubungi pasukan hubungan pelabur melalui saluran di bawah.',
    'careers.eyebrow': 'Kerjaya',
    'careers.title': 'Cari tempat anda dalam lima perniagaan',
    'careers.lead': 'Kami mengupah di Nanning dan mengalu-alukan bakat yang berminat dengan kerja kami yang menyasarkan ASEAN.',
    'careers.social.title': 'Pengambilan berpengalaman',
    'careers.social.lead': 'Jawatan berikut terbuka untuk permohonan.',
    'careers.apply': 'Mohon',
    'careers.campus.title': 'Pengambilan kampus',
    'careers.form.title': 'Permohonan',
    'careers.form.success': 'Terima kasih. Borang ini belum disambungkan kepada sistem pengambilan kami, jadi permohonan anda tidak disimpan.',
    'contact.eyebrow': 'Hubungi',
    'contact.title': 'Beritahu kami keperluan anda',
    'contact.lead': 'Pertanyaan perniagaan, permintaan media, perbincangan pelabur dan kerjasama bakat semuanya bermula di sini.',
    'contact.address': 'Ibu pejabat',
    'contact.channels': 'Saluran',
    'contact.form.title': 'Pertanyaan',
    'contact.form.success': 'Terima kasih. Borang ini belum disambungkan kepada sistem kami, jadi mesej anda tidak disimpan.',
    'form.required': '* wajib diisi',
    'form.submit': 'Hantar',
    'form.note': 'Borang ini belum disambungkan kepada sistem kami, jadi penghantaran tidak disimpan atau dihantar. Untuk respons segera, sila gunakan butiran hubungan di atas.',
    'form.select': 'Sila pilih',
    'form.name': 'Nama',
    'form.phone': 'Telefon bimbit',
    'form.email': 'E-mel',
    'form.company': 'Syarikat atau organisasi',
    'form.role': 'Peranan yang diminati',
    'form.direction': 'Pertanyaan mengenai',
    'form.message': 'Mesej',
    'dir.media': 'Media',
    'dir.tech': 'Perkhidmatan teknologi',
    'dir.health': 'Kesihatan',
    'dir.logistics': 'Logistik',
    'dir.invest': 'Pelaburan industri',
    'dir.ir': 'Hubungan pelabur',
    'dir.other': 'Lain-lain',
    'notfound.title': 'Halaman tidak ditemui',
    'notfound.body': 'Laluan ini tidak ditakrifkan.',
  },
  km: {
    'nav.publications': 'ឯកសារបោះពុម្ពរបស់ក្រុមហ៊ុន',
    'pub.eyebrow': 'ឯកសារបោះពុម្ពរបស់ក្រុមហ៊ុន',
    'pub.title': 'ឯកសារបោះពុម្ពរបស់ក្រុមហ៊ុន',
    'pub.type.letter': 'លិខិតប្រចាំឆ្នាំ',
    'pub.type.review': 'ទិដ្ឋភាពរួមប្រចាំឆ្នាំ',
    'pub.type.esg': 'ការទទួលខុសត្រូវសង្គម',
    'pub.type.facts': 'ទិន្នន័យ និងតួលេខ',
    'pub.notice': 'ខ្លឹមសារនៅក្នុងទំព័រនេះជាព័ត៌មានទូទៅក្នុងកម្រិតក្រុម មិនមែនជាដំបូន្មានវិនិយោគ ឬការសន្យាអំពីលទ្ធផលនោះទេ។ សេចក្តីថ្លែងការណ៍អំពីហិរញ្ញវត្ថុ និងគោលនយោបាយ ត្រូវយោងតាមឯកសារដើម និងការសម្រេចចុងក្រោយរបស់អាជ្ញាធរមានសមត្ថកិច្ច។',
    'brand.name': 'Andi Culture',
    'brand.mark': 'ri-building-2-line',
    'brand.home': 'ផតថលក្រុម',
    'nav.about': 'អំពីក្រុម',
    'nav.leadership': 'ថ្នាក់ដឹកនាំ',
    'nav.ecosystem': 'ប្រព័ន្ធអេកូអាជីវកម្ម',
    'nav.news': 'ព័ត៌មាន',
    'nav.esg': 'ESG',
    'nav.ir': 'ទំនាក់ទំនងវិនិយោគិន',
    'nav.careers': 'ឱកាសការងារ',
    'nav.contact': 'ទំនាក់ទំនង',
    'footer.note':
      'វេទិកាផ្សព្វផ្សាយព័ត៌មានរបស់ Andi Culture។ ក្រេឌីតរូបភាពបង្ហាញនៅក្រោមរូបភាពនីមួយៗ។',
    'footer.ecosystem': 'ប្រព័ន្ធអេកូអាជីវកម្ម',
    'footer.site': 'Andi Culture',
    'common.visit': 'ចូលទស្សនា',
    'common.more': 'ស្វែងយល់បន្ថែម',
    'common.placeholderVisual': 'រូបភាពផ្នែកអាជីវកម្ម',
    'common.imageCredit': 'រូបភាព',

    'home.hero.eyebrow': 'Andi Culture · Nanning',
    'home.hero.cta.ecosystem': 'ស្វែងយល់ប្រព័ន្ធអេកូអាជីវកម្ម',
    'home.hero.cta.about': 'អំពីក្រុម',
    'home.eco.eyebrow': 'ប្រព័ន្ធអេកូអាជីវកម្ម',
    'home.eco.title': 'អាជីវកម្មទាំងប្រាំ ចូលបានដោយចុចតែម្តង',
    'home.eco.lead': 'ផ្នែកអាជីវកម្មនីមួយៗមានគេហទំព័រ និងផ្នែកផ្ទាល់ខ្លួន។ សូមជ្រើសរើសមួយដើម្បីចូល។',
    'home.about.eyebrow': 'អំពីក្រុម',
    'home.about.title': 'ការិយាល័យកណ្តាលនៅ Nanning ភ្ជាប់អាជីវកម្មទាំងប្រាំ',
    'home.about.more': 'មើលទិដ្ឋភាពរួមក្រុម',
    'home.facts.founded': 'ឆ្នាំបង្កើត',
    'home.facts.capital': 'ដើមទុនចុះបញ្ជី',
    'home.facts.hq': 'ការិយាល័យកណ្តាល',
    'home.facts.lines': 'ផ្នែកអាជីវកម្ម',
    'home.facts.linesValue': '5',
    'home.news.eyebrow': 'ព័ត៌មាន',
    'home.news.title': 'ព័ត៌មានថ្មីៗ',
    'home.news.all': 'ព័ត៌មានទាំងអស់',
    'home.esg.eyebrow': 'ESG និងការទទួលខុសត្រូវសង្គម',
    'home.esg.title': 'ចាក់ឫសក្នុងតំបន់ ទទួលខុសត្រូវចំពោះបរិស្ថាន និងសហគមន៍',
    'home.esg.env': 'បរិស្ថាន',
    'home.esg.env.body': 'ផ្តោតលើការបំពេញការងារបៃតង និងប្រតិបត្តិការសន្សំថាមពល ព្រមទាំងបង្ហាញសូចនាករបរិស្ថានសំខាន់ៗជាដំណាក់កាល។',
    'home.esg.social': 'សង្គម',
    'home.esg.social.body': 'បម្រើអតិថិជន និងដៃគូក្នុងតំបន់ ព្រមទាំងគាំទ្រការអភិវឌ្ឍធនធានមនុស្ស និងសកម្មភាពសហគមន៍។',
    'home.esg.gov': 'អភិបាលកិច្ច',
    'home.esg.gov.body': 'ផ្នែកអាជីវកម្មនីមួយៗធ្វើគណនេយ្យ និងទទួលខុសត្រូវដោយឯករាជ្យ រីឯក្រុមកំណត់ការអនុលោម និងការគ្រប់គ្រងហានិភ័យរួមគ្នា។',
    'home.esg.cta': 'មើលប្រធានបទ ESG',
    'home.join.title': 'ចូលរួមជាមួយយើង និងរីកចម្រើនជាមួយអាជីវកម្មទាំងប្រាំ',
    'home.join.lead': 'យើងជ្រើសរើសបុគ្គលិកជាបន្តបន្ទាប់នៅ Nanning តំបន់ Guangxi និងតួនាទីឆ្ពោះទៅ ASEAN។',
    'home.join.cta': 'មើលមុខតំណែងទំនេរ',
    'home.join.contact': 'ទំនាក់ទំនងយើង',

    'about.eyebrow': 'អំពីក្រុម',
    'about.intro.title': 'អំពីយើង',
    'about.values.title': 'បេសកកម្ម ចក្ខុវិស័យ និងតម្លៃ',
    'about.history.title': 'គោលសម្គាល់ការរីកចម្រើន',
    'about.history.lead': 'ចាប់ពីការបង្កើតការិយាល័យកណ្តាលក្នុងឆ្នាំ 2023 ក្រុមបានបង្កើតផ្នែកអាជីវកម្មទាំងប្រាំជាបន្តបន្ទាប់ តាមផ្លូវចាក់ឫសក្នុងតំបន់ និងពង្រីកដោយសហការ។',
    'about.structure.title': 'រចនាសម្ព័ន្ធ',
    'about.structure.lead': 'ការិយាល័យកណ្តាលកំណត់យុទ្ធសាស្ត្រ យីហោ ហិរញ្ញវត្ថុ និងការអនុលោមរួម។ ផ្នែកអាជីវកម្មនីមួយៗដំណើរការ និងទទួលខុសត្រូវដោយខ្លួនឯង។',
    'about.structure.root': 'Andi Culture · ការិយាល័យកណ្តាល',
    'about.banner.credit': 'រូបភាព៖ Nanning International Convention and Exhibition Center (Wikimedia Commons, CC BY-SA 4.0, EditQ)',

    'eco.eyebrow': 'ប្រព័ន្ធអេកូអាជីវកម្ម',
    'eco.title': 'ផ្នែកអាជីវកម្មទាំងប្រាំ',
    'eco.lead': 'ក្រុមហ៊ុនបុត្រសម្ព័ន្ធនីមួយៗបង្ហាញពីទីតាំងរបស់ខ្លួន ហើយក៏ចែករំលែកឆានែល ការបំពេញការងារ និងធនធានជាមួយក្រុម។',
    'eco.keywords': 'ពាក្យគន្លឹះ',
    'eco.banner.credit': 'រូបភាព៖ ទិដ្ឋភាពផ្តេកនៃជួរអគារទីក្រុង Nanning (Wikimedia Commons, CC BY 4.0, MspreilsCN)',

    'ph.eyebrow': 'កំពុងអនុវត្ត',
    'ph.title': 'ទំព័រនេះនឹងចេញផ្សាយក្នុងដំណាក់កាលបន្ទាប់',
    'ph.body': 'រចនាសម្ព័ន្ធទំព័រ និងបញ្ជីខ្លឹមសារត្រូវបានកំណត់ក្នុងឯកសារផែនទីគេហទំព័រ និងបញ្ជីខ្លឹមសារ ហើយការអនុវត្តនឹងធ្វើឡើងបន្ទាប់ពីការអនុម័តរចនាប័ទ្ម។',

    'skip': 'លោតទៅខ្លឹមសារ',
    'lead.eyebrow': 'ថ្នាក់ដឹកនាំក្រុម',
    'lead.banner': 'ប្រធានក្រុមប្រឹក្សាភិបាលចែករំលែកអំពីយុទ្ធសាស្ត្រក្រុម ការសហការអាជីវកម្ម និងការទទួលខុសត្រូវរយៈពេលវែង។',
    'lead.team.title': 'ក្រុមថ្នាក់ដឹកនាំ',
    'lead.team.lead': 'សមាជិកក្រុមថ្នាក់ដឹកនាំក្រុម។',
    'lead.portrait': 'រូបភាពសាររបស់ប្រធាន',
    'news.eyebrow': 'ព័ត៌មាន',
    'news.title': 'ព័ត៌មានថ្មីៗពីក្រុម និងក្រុមហ៊ុនបុត្រសម្ព័ន្ធ',
    'news.lead': 'ការសម្រេចចិត្តកម្រិតក្រុម វឌ្ឍនភាពនៃអាជីវកម្មនីមួយៗ និងសេចក្តីជូនដំណឹងអំពីការទទួលខុសត្រូវសង្គម ត្រូវបានផ្សាយនៅទីនេះ។',
    'news.filter.all': 'ទាំងអស់',
    'news.filter.group': 'ក្រុម',
    'news.filter.subsidiary': 'ក្រុមហ៊ុនបុត្រសម្ព័ន្ធ',
    'news.filter.esg': 'ESG',
    'news.empty': 'មិនទាន់មានព័ត៌មានក្នុងប្រភេទនេះទេ។',
    'news.readMore': 'អានបន្ថែម',
    'news.back': 'ត្រឡប់ទៅបញ្ជីព័ត៌មាន',
    'news.related': 'ព័ត៌មានពាក់ព័ន្ធ',
    'news.notFound': 'រកមិនឃើញអត្ថបទនេះទេ ប្រហែលជាត្រូវបានដកចេញ។',
    'esg.eyebrow': 'ESG និងការទទួលខុសត្រូវសង្គម',
    'esg.title': 'ទទួលខុសត្រូវចំពោះបរិស្ថាន សហគមន៍ និងអភិបាលកិច្ច ដោយប្តូរការសន្យាទៅជាសកម្មភាពដែលអាចផ្ទៀងផ្ទាត់បាន',
    'esg.lead': 'យើងចាត់ទុកការទទួលខុសត្រូវសង្គមស្មើនឹងអាជីវកម្ម។ ប្រធានបទ និងទិសដៅសកម្មភាពខាងក្រោមជាដំណាក់កាល ហើយសូចនាករជាក់លាក់នឹងត្រូវបង្ហាញជាបន្តបន្ទាប់តាមរបាយការណ៍។',
    'esg.pillars.title': 'ប្រធានបទសំខាន់ទាំងបី',
    'esg.programs.title': 'កម្មវិធីសាធារណៈប្រយោជន៍ និងសហគមន៍',
    'esg.programs.lead': 'កម្មវិធី ESG របស់យើងកំពុងដំណើរការជាបន្តបន្ទាប់។',
    'esg.reports.title': 'របាយការណ៍ទទួលខុសត្រូវសង្គម',
    'esg.reports.lead': 'របាយការណ៍នឹងចេញផ្សាយបន្ទាប់ពីរៀបចំរួច និងឆ្លងកាត់ការពិនិត្យរបស់ក្រុមប្រឹក្សាភិបាល។',
    'esg.reports.soon': 'នឹងចេញផ្សាយឆាប់ៗ',
    'esg.banner.credit': 'រូបភាព៖ ទន្លេ Li និងកំពូលភ្នំថ្មកំបោរនៅ Yangshuo (Wikimedia Commons, CC0, Huangdan2060)',
    'ir.eyebrow': 'ទំនាក់ទំនងវិនិយោគិន',
    'ir.title': 'លក្ខខណ្ឌ សេចក្តីសង្ខេបហិរញ្ញវត្ថុ និងរចនាសម្ព័ន្ធភាគហ៊ុន',
    'ir.lead': 'ចំណូលត្រូវបានទទួលស្គាល់តាមវិធីសាស្ត្រពេញលេញ។ ជំនួយរដ្ឋាភិបាលត្រូវកត់ត្រាក្នុងចំណូលផ្សេង មិនរាប់បញ្ចូលក្នុងចំណូលអាជីវកម្មឡើយ។',
    'ir.round.title': 'វគ្គហ៊ុនបច្ចុប្បន្ន',
    'ir.round.target': 'គោលដៅទុនប្រមូល',
    'ir.round.equity': 'ភាគហ៊ុនដែលនឹងផ្តល់ជូន',
    'ir.round.pre': 'ការវាយតម្លៃមុនវិនិយោគ',
    'ir.round.post': 'ការវាយតម្លៃក្រោយវិនិយោគ',
    'ir.round.instrument': 'ឧបករណ៍ហិរញ្ញវត្ថុ',
    'ir.use.title': 'ការប្រើប្រាស់ទុន',
    'ir.use.lead': 'ទុននីមួយៗភ្ជាប់នឹងគោលសម្គាល់ដែលអាចផ្ទៀងផ្ទាត់បាន។',
    'ir.fin.title': 'សេចក្តីសង្ខេបហិរញ្ញវត្ថុ',
    'ir.fin.lead': 'ឆ្នាំ {year} តាមរបៀបបូកបញ្ចូល។',
    'ir.fin.revenue': 'ចំណូល',
    'ir.fin.grossMargin': 'អត្រាចំណេញដុល',
    'ir.fin.netProfit': 'ចំណេញសុទ្ធ',
    'ir.fin.netMargin': 'អត្រាចំណេញសុទ្ធ',
    'ir.fin.otherIncome': 'ចំណូលផ្សេង (ជំនួយរដ្ឋាភិបាល)',
    'ir.fin.grant': 'សមាមាត្រជំនួយលើចំណេញសុទ្ធ',
    'ir.fin.note': 'ជំនួយរដ្ឋាភិបាលត្រូវកត់ត្រាក្នុងចំណូលផ្សេង មិនរាប់បញ្ចូលក្នុងចំណូលអាជីវកម្មឡើយ។ ការលើកលែងពន្ធកាត់បន្ថយចំណាយពន្ធលើប្រាក់ចំណូល។',
    'ir.cap.title': 'រចនាសម្ព័ន្ធភាគហ៊ុន',
    'ir.cap.lead': 'រចនាសម្ព័ន្ធភាគហ៊ុនយោងតាមបញ្ជីឈ្មោះភាគទុនិកផ្លូវការរបស់ក្រុម។',
    'ir.history.title': 'ប្រវត្តិនៃការប្រមូលទុន',
    'ir.history.round': 'វគ្គ',
    'ir.history.date': 'កាលបរិច្ឆេទ',
    'ir.history.amount': 'ចំនួនទឹកប្រាក់',
    'ir.history.equity': 'ភាគហ៊ុន',
    'ir.history.post': 'ក្រោយវិនិយោគ',
    'ir.contact.title': 'ទំនាក់ទំនងវិនិយោគិន',
    'ir.contact.lead': 'ដើម្បីទទួលបានឯកសារត្រួតពិនិត្យសុពលភាព សូមទាក់ទងក្រុមទំនាក់ទំនងវិនិយោគិនតាមឆានែលខាងក្រោម។',
    'careers.eyebrow': 'ឱកាសការងារ',
    'careers.title': 'ស្វែងរកទីតាំងរបស់អ្នកក្នុងអាជីវកម្មទាំងប្រាំ',
    'careers.lead': 'យើងជ្រើសរើសបុគ្គលិកនៅ Nanning ហើយស្វាគមន៍អ្នកមានសមត្ថភាពដែលចាប់អារម្មណ៍លើការងារឆ្ពោះទៅ ASEAN។',
    'careers.social.title': 'ការជ្រើសរើសអ្នកមានបទពិសោធន៍',
    'careers.social.lead': 'មុខតំណែងខាងក្រោមកំពុងបើកទទួលពាក្យ។',
    'careers.apply': 'ដាក់ពាក្យ',
    'careers.campus.title': 'ការជ្រើសរើសនិស្សិត',
    'careers.form.title': 'ការដាក់ពាក្យ',
    'careers.form.success': 'សូមអរគុណ។ ទម្រង់នេះមិនទាន់ភ្ជាប់ទៅប្រព័ន្ធជ្រើសរើសបុគ្គលិករបស់យើងទេ ដូច្នេះពាក្យសុំរបស់អ្នកមិនត្រូវបានរក្សាទុកឡើយ។',
    'contact.eyebrow': 'ទំនាក់ទំនង',
    'contact.title': 'ប្រាប់យើងពីតម្រូវការរបស់អ្នក',
    'contact.lead': 'ការសាកសួរអាជីវកម្ម សំណើពីសារព័ត៌មាន ការពិភាក្សាជាមួយវិនិយោគិន និងកិច្ចសហការផ្នែកធនធានមនុស្ស អាចចាប់ផ្តើមពីទីនេះ។',
    'contact.address': 'ការិយាល័យកណ្តាល',
    'contact.channels': 'ឆានែលទំនាក់ទំនង',
    'contact.form.title': 'សារ និងការសាកសួរ',
    'contact.form.success': 'សូមអរគុណ។ ទម្រង់នេះមិនទាន់ភ្ជាប់ទៅប្រព័ន្ធរបស់យើងទេ ដូច្នេះសាររបស់អ្នកមិនត្រូវបានរក្សាទុកឡើយ។',
    'form.required': '* ត្រូវបំពេញ',
    'form.submit': 'ផ្ញើ',
    'form.note': 'ទម្រង់នេះមិនទាន់ភ្ជាប់ទៅប្រព័ន្ធរបស់យើងទេ ដូច្នេះការផ្ញើមិនត្រូវបានរក្សាទុក ឬបញ្ជូនឡើយ។ ប្រសិនបើត្រូវការទំនាក់ទំនងភ្លាមៗ សូមប្រើព័ត៌មានទំនាក់ទំនងខាងលើ។',
    'form.select': 'សូមជ្រើសរើស',
    'form.name': 'ឈ្មោះ',
    'form.phone': 'លេខទូរស័ព្ទ',
    'form.email': 'អ៊ីមែល',
    'form.company': 'ក្រុមហ៊ុន ឬស្ថាប័ន',
    'form.role': 'មុខតំណែងដែលចាប់អារម្មណ៍',
    'form.direction': 'ប្រធានបទសាកសួរ',
    'form.message': 'ខ្លឹមសារសារ',
    'dir.media': 'ប្រព័ន្ធផ្សព្វផ្សាយ',
    'dir.tech': 'សេវាបច្ចេកវិទ្យា',
    'dir.health': 'សុខាភិបាល',
    'dir.logistics': 'ដឹកជញ្ជូន និងខ្សែសង្វាក់ផ្គត់ផ្គង់',
    'dir.invest': 'វិនិយោគឧស្សាហកម្ម',
    'dir.ir': 'ទំនាក់ទំនងវិនិយោគិន',
    'dir.other': 'ផ្សេងៗ',
    'notfound.title': 'រកមិនឃើញទំព័រ',
    'notfound.body': 'ផ្លូវនេះមិនត្រូវបានកំណត់ឡើយ។',
  },
  ja: {
    'nav.publications': 'グループ刊行物',
    'pub.eyebrow': 'グループ刊行物',
    'pub.title': 'グループ刊行物',
    'pub.type.letter': '年次レター',
    'pub.type.review': '年間レビュー',
    'pub.type.esg': '社会的責任',
    'pub.type.facts': 'データと数値',
    'pub.notice': '本ページの内容はグループ全体に関する一般情報であり、投資助言や業績の約束を構成するものではありません。財務および政策に関する記載は、原資料および所管当局の最終的な認定に基づきます。',
    'brand.name': 'Andi Culture',
    'brand.mark': 'ri-building-2-line',
    'brand.home': 'グループポータル',
    'nav.about': 'グループ概要',
    'nav.leadership': 'ご挨拶',
    'nav.ecosystem': '事業エコシステム',
    'nav.news': 'ニュース',
    'nav.esg': 'ESG',
    'nav.ir': '投資家情報',
    'nav.careers': '採用情報',
    'nav.contact': 'お問い合わせ',
    'footer.note':
      'Andi Culture の情報発信プラットフォームです。画像のクレジットは各画像の下に記載しています。',
    'footer.ecosystem': '事業エコシステム',
    'footer.site': 'Andi Culture',
    'common.visit': 'サイトを見る',
    'common.more': '詳しく見る',
    'common.placeholderVisual': '事業セグメントのイメージ',
    'common.imageCredit': '画像',

    'home.hero.eyebrow': 'Andi Culture · Nanning',
    'home.hero.cta.ecosystem': '事業エコシステムを見る',
    'home.hero.cta.about': 'グループについて',
    'home.eco.eyebrow': '事業エコシステム',
    'home.eco.title': '5つの事業へ、ワンクリックで',
    'home.eco.lead': '各事業は独自のウェブサイトとセクションを持っています。選択すると該当サイトへ移動します。',
    'home.about.eyebrow': 'グループ概要',
    'home.about.title': '本社は Nanning、5つの事業をつなぐ',
    'home.about.more': 'グループ概要を見る',
    'home.facts.founded': '設立',
    'home.facts.capital': '登録資本金',
    'home.facts.hq': '本社所在地',
    'home.facts.lines': '事業セグメント',
    'home.facts.linesValue': '5',
    'home.news.eyebrow': 'ニュース',
    'home.news.title': '最新情報',
    'home.news.all': 'すべてのニュース',
    'home.esg.eyebrow': 'ESGと社会的責任',
    'home.esg.title': '地域に根ざし、環境とコミュニティに責任を持つ',
    'home.esg.env': '環境',
    'home.esg.env.body': 'グリーンな物流遂行と省エネ運営に取り組み、主要な環境指標を順次開示します。',
    'home.esg.social': '社会',
    'home.esg.social.body': '地域の顧客とパートナーにサービスを提供し、人材育成とコミュニティ活動を支援します。',
    'home.esg.gov': 'ガバナンス',
    'home.esg.gov.body': '各事業は独立して会計処理と責任を負い、グループがコンプライアンスとリスク管理を統一的に定めます。',
    'home.esg.cta': 'ESGの取り組みを見る',
    'home.join.title': '5つの事業とともに成長しませんか',
    'home.join.lead': 'Nanning、広西、およびASEAN向けの職務で継続的に採用しています。',
    'home.join.cta': '募集職種を見る',
    'home.join.contact': 'お問い合わせ',

    'about.eyebrow': 'グループ概要',
    'about.intro.title': 'グループについて',
    'about.values.title': 'ミッション・ビジョン・バリュー',
    'about.history.title': '沿革',
    'about.history.lead': '2023年の本社設立以来、グループは「地域に根ざし、連携して拡大する」方針のもと、5つの事業セグメントを順次形成してきました。',
    'about.structure.title': '組織体制',
    'about.structure.lead': 'グループ本社が戦略、ブランド、財務、コンプライアンスを統括し、各事業セグメントは独立して運営し責任を負います。',
    'about.structure.root': 'Andi Culture · 本社',
    'about.banner.credit': '画像：Nanning International Convention and Exhibition Center（Wikimedia Commons、CC BY-SA 4.0、EditQ）',

    'eco.eyebrow': '事業エコシステム',
    'eco.title': '5つの事業セグメント',
    'eco.lead': '各子会社は自らの立ち位置を発信しつつ、チャネル、物流遂行、リソースの面でグループと連携します。',
    'eco.keywords': 'キーワード',
    'eco.banner.credit': '画像：Nanning 市街地のスカイライン全景（Wikimedia Commons、CC BY 4.0、MspreilsCN）',

    'ph.eyebrow': '準備中',
    'ph.title': '本ページは次フェーズで公開予定です',
    'ph.body': 'ページ構成とコンテンツ一覧は「サイトマップとコンテンツ一覧」で定めており、デザイン確認後に実装します。',

    'skip': '本文へスキップ',
    'lead.eyebrow': 'グループ経営陣',
    'lead.banner': 'グループ戦略、事業シナジー、長期的な責任についての会長メッセージ。',
    'lead.team.title': '経営陣',
    'lead.team.lead': 'グループ経営陣のメンバーです。',
    'lead.portrait': '会長メッセージのイメージ',
    'news.eyebrow': 'ニュース',
    'news.title': 'グループと子会社の最新情報',
    'news.lead': 'グループの決定、各事業の進捗、社会的責任に関するお知らせをここにまとめて掲載します。',
    'news.filter.all': 'すべて',
    'news.filter.group': 'グループ',
    'news.filter.subsidiary': '子会社',
    'news.filter.esg': '社会的責任',
    'news.empty': 'このカテゴリの記事はまだありません。',
    'news.readMore': '全文を読む',
    'news.back': 'ニュース一覧へ戻る',
    'news.related': '関連ニュース',
    'news.notFound': 'この記事は見つかりませんでした。削除された可能性があります。',
    'esg.eyebrow': 'ESGと社会的責任',
    'esg.title': '環境・コミュニティ・ガバナンスに責任を持ち、約束を検証可能な行動に結びつける',
    'esg.lead': '私たちは社会的責任を事業と同等に位置づけています。以下の重点課題と行動方針は段階的なもので、具体的な指標は報告書に沿って順次開示します。',
    'esg.pillars.title': '3つの重点課題',
    'esg.programs.title': '社会貢献・コミュニティプログラム',
    'esg.programs.lead': 'ESGプログラムは継続的に実施しています。',
    'esg.reports.title': '社会的責任報告書',
    'esg.reports.lead': '報告書は作成完了後、取締役会の審議を経て公表します。',
    'esg.reports.soon': '公開予定',
    'esg.banner.credit': '画像：Yangshuo の漓江とカルスト峰（Wikimedia Commons、CC0、Huangdan2060）',
    'ir.eyebrow': '投資家情報',
    'ir.title': '資金調達条件、財務サマリー、株式構成',
    'ir.lead': '収益は総額法で認識します。政府補助金はその他の収益に計上し、売上高には含めません。',
    'ir.round.title': '今回の資金調達',
    'ir.round.target': '調達目標額',
    'ir.round.equity': '拠出予定株式',
    'ir.round.pre': 'プレマネー評価額',
    'ir.round.post': 'ポストマネー評価額',
    'ir.round.instrument': '調達手段',
    'ir.use.title': '資金使途',
    'ir.use.lead': '各資金使途は検証可能なマイルストーンに対応します。',
    'ir.fin.title': '財務サマリー',
    'ir.fin.lead': '{year}年度、連結ベース。',
    'ir.fin.revenue': '売上高',
    'ir.fin.grossMargin': '売上総利益率',
    'ir.fin.netProfit': '当期純利益',
    'ir.fin.netMargin': '当期純利益率',
    'ir.fin.otherIncome': 'その他の収益（政府補助金）',
    'ir.fin.grant': '当期純利益に占める補助金の割合',
    'ir.fin.note': '政府補助金はその他の収益に計上し、売上高には含めません。税制優遇は法人税費用を減額します。',
    'ir.cap.title': '株式構成',
    'ir.cap.lead': '株式構成はグループの正式な株主名簿に基づきます。',
    'ir.history.title': '資金調達の沿革',
    'ir.history.round': 'ラウンド',
    'ir.history.date': '時期',
    'ir.history.amount': '金額',
    'ir.history.equity': '拠出株式',
    'ir.history.post': 'ポストマネー',
    'ir.contact.title': '投資家向けお問い合わせ',
    'ir.contact.lead': 'デューデリジェンス資料が必要な場合は、以下の窓口から投資家情報担当までご連絡ください。',
    'careers.eyebrow': '採用情報',
    'careers.title': '5つの事業であなたの居場所を',
    'careers.lead': '私たちは Nanning で採用を行っており、ASEAN向け事業に関心のある方のご応募を歓迎します。',
    'careers.social.title': '中途採用',
    'careers.social.lead': '以下の職種を随時募集しています。ぜひご応募ください。',
    'careers.apply': '応募する',
    'careers.campus.title': '新卒採用',
    'careers.form.title': '応募フォーム',
    'careers.form.success': 'ご応募ありがとうございます。本フォームは採用システムに接続していないため、応募内容は保存されません。',
    'contact.eyebrow': 'お問い合わせ',
    'contact.title': 'ご要望をお聞かせください',
    'contact.lead': '事業に関するご相談、取材依頼、投資家との対話、人材に関する連携など、こちらからお寄せください。',
    'contact.address': '本社所在地',
    'contact.channels': '連絡窓口',
    'contact.form.title': 'お問い合わせ',
    'contact.form.success': 'お問い合わせありがとうございます。本フォームはシステムに接続していないため、内容は保存されません。',
    'form.required': '* は必須',
    'form.submit': '送信',
    'form.note': '本フォームはシステムに接続していないため、送信内容は保存も送信もされません。すぐにご連絡が必要な場合は、上部の連絡先をご利用ください。',
    'form.select': '選択してください',
    'form.name': 'お名前',
    'form.phone': '携帯電話番号',
    'form.email': 'メールアドレス',
    'form.company': '会社・団体名',
    'form.role': '希望職種',
    'form.direction': 'お問い合わせ内容',
    'form.message': 'お問い合わせ本文',
    'dir.media': '文化メディア',
    'dir.tech': 'テクノロジーサービス',
    'dir.health': '健康管理',
    'dir.logistics': '物流・サプライチェーン',
    'dir.invest': '産業投資',
    'dir.ir': '投資家情報',
    'dir.other': 'その他',
    'notfound.title': 'ページが見つかりません',
    'notfound.body': 'このパスは定義されていません。',
  },
};
